// src/pages/CanadaVisa/FormStepsCanada.js
import { useState } from 'react';
import InputField from '../../components/InputField';
import styles from '../../App.module.css';

// Lista de províncias canadenses
export const provinciasCanada = [
    'Alberta', 'British Columbia', 'Manitoba', 'New Brunswick',
    'Newfoundland and Labrador', 'Nova Scotia', 'Ontario',
    'Prince Edward Island', 'Quebec', 'Saskatchewan',
    'Northwest Territories', 'Nunavut', 'Yukon'
];

// Estado inicial do formulário para visto canadense
export function useCanadaFormState() {
    const initialState = {
        nome: '',
        sobrenome: '',
        cidadeNascimento: '',
        sexo: '',
        estadoNascimento: '',
        dataNascimento: '',
        cpf: '',
        estadoCivil: '',
        alteracaoNome: '',
        detalhesAlteracaoNome: '',
        detalhesAlteracaoSobreNome: '',
        possuiOutraNacionalidade: '',
        email: '',
        telefone: '',
        endereco: '',
        cursoOuProfissao: '',
        escolaridade: '',
        instituicaoAtual: '',
        comprovanteVinculo: null,
        motivoViagem: '',
        datasPretendidas: '',
        enderecoHospedagem: '',
        cartaConvite: null,
        cartaCusteio: null,
        comprovanteFinanceiro: null,
        // Dados do passaporte
        dataEmissaoPassaporte: '',
        dataExpiracaoPassaporte: '',
        numeroPassaporte: '',
        numeroPassaporteOutraNacionalidade: '',
        cidadeEstadoEmissaoPassaporte: '',
        passaporteRoubadoPerdido: '',
        numeroPassaportePerdido: '',
        paisEmissaoPassaportePerdido: '',
        detalhesPassaportePerdido: '',
        acompanhantes: [],        // ← precisa existir
        itinerioCidades: [],      // ← também precisa existir
        temFilhos: '',
        filhos: [],
        viagensInternacionais: 'nao', // ou 'sim'
        listaViagens: [],             // evita undefined

    };

    const [formData, setFormData] = useState(initialState);
    // Função para atualizar o estado do formulário
    const setFormField = (field, value) => {
        if (typeof field === 'object') {
            setFormData((prevData) => ({ ...prevData, ...field })); // Atualização em massa
        } else {
            setFormData((prevData) => ({ ...prevData, [field]: value })); // Atualização de um campo
        }
    };
    return [formData, setFormField];
}

export const sanitizeNumberInput = (e, callback) => {
    const onlyNumbers = e.target.value.replace(/\D/g, '');
    callback({
        target: {
            name: e.target.name,
            value: onlyNumbers
        }
    });
};



// src/constants/estados.js
export const estadosBrasileiros = [
    { value: "Acre", label: "Acre" },
    { value: "Alagoas", label: "Alagoas" },
    { value: "Amapa", label: "Amapá" },
    { value: "Amazonas", label: "Amazonas" },
    { value: "Bahia", label: "Bahia" },
    { value: "Ceara", label: "Ceará" },
    { value: "Distrito Federal", label: "Distrito Federal" },
    { value: "Espirito Santo", label: "Espírito Santo" },
    { value: "Goias", label: "Goiás" },
    { value: "Maranhao", label: "Maranhão" },
    { value: "Mato Grosso", label: "Mato Grosso" },
    { value: "Mato Grosso do Sul", label: "Mato Grosso do Sul" },
    { value: "Minas Gerais", label: "Minas Gerais" },
    { value: "Para", label: "Pará" },
    { value: "Paraiba", label: "Paraíba" },
    { value: "Parana", label: "Paraná" },
    { value: "Pernambuco", label: "Pernambuco" },
    { value: "Piaui", label: "Piauí" },
    { value: "Rio De Janeiro", label: "Rio de Janeiro" },
    { value: "Rio Grande do Norte", label: "Rio Grande do Norte" },
    { value: "Rio Grande do Sul", label: "Rio Grande do Sul" },
    { value: "Rondonia", label: "Rondônia" },
    { value: "Roraima", label: "Roraima" },
    { value: "Santa Catarina", label: "Santa Catarina" },
    { value: "SaoPaulo", label: "São Paulo" },
    { value: "Sergipe", label: "Sergipe" },
    { value: "Tocantins", label: "Tocantins" },
]

export const nacionalidades = [
    { value: "AFGH", label: "AFGHANISTAN" },
    { value: "ALB", label: "ALBANIA" },
    { value: "ALGR", label: "ALGERIA" },
    { value: "ASMO", label: "AMERICAN SAMOA" },
    { value: "ANDO", label: "ANDORRA" },
    { value: "ANGL", label: "ANGOLA" },
    { value: "ANGU", label: "ANGUILLA" },
    { value: "ANTI", label: "ANTIGUA AND BARBUDA" },
    { value: "ARG", label: "ARGENTINA" },
    { value: "ARM", label: "ARMENIA" },
    { value: "ARB", label: "ARUBA" },
    { value: "XAS", label: "AT SEA" },
    { value: "ASTL", label: "AUSTRALIA" },
    { value: "AUST", label: "AUSTRIA" },
    { value: "AZR", label: "AZERBAIJAN" },
    { value: "BAMA", label: "BAHAMAS" },
    { value: "BAHR", label: "BAHRAIN" },
    { value: "BANG", label: "BANGLADESH" },
    { value: "BRDO", label: "BARBADOS" },
    { value: "BYS", label: "BELARUS" },
    { value: "BELG", label: "BELGIUM" },
    { value: "BLZ", label: "BELIZE" },
    { value: "BENN", label: "BENIN" },
    { value: "BERM", label: "BERMUDA" },
    { value: "BHU", label: "BHUTAN" },
    { value: "BOL", label: "BOLIVIA" },
    { value: "BIH", label: "BOSNIA-HERZEGOVINA" },
    { value: "BOT", label: "BOTSWANA" },
    { value: "BRZL", label: "BRAZIL" },
    { value: "IOT", label: "BRITISH INDIAN OCEAN TERRITORY" },
    { value: "BRNI", label: "BRUNEI" },
    { value: "BULG", label: "BULGARIA" },
    { value: "BURK", label: "BURKINA FASO" },
    { value: "BURM", label: "BURMA" },
    { value: "BRND", label: "BURUNDI" },
    { value: "CBDA", label: "CAMBODIA" },
    { value: "CMRN", label: "CAMEROON" },
    { value: "CAN", label: "CANADA" },
    { value: "CAVI", label: "CABO VERDE" },
    { value: "CAYI", label: "CAYMAN ISLANDS" },
    { value: "CAFR", label: "CENTRAL AFRICAN REPUBLIC" },
    { value: "CHAD", label: "CHAD" },
    { value: "CHIL", label: "CHILE" },
    { value: "CHIN", label: "CHINA" },
    { value: "CHRI", label: "CHRISTMAS ISLAND" },
    { value: "COCI", label: "COCOS KEELING ISLANDS" },
    { value: "COL", label: "COLOMBIA" },
    { value: "COMO", label: "COMOROS" },
    { value: "COD", label: "CONGO, DEMOCRATIC REPUBLIC OF THE" },
    { value: "CONB", label: "CONGO, REPUBLIC OF THE" },
    { value: "CKIS", label: "COOK ISLANDS" },
    { value: "CSTR", label: "COSTA RICA" },
    { value: "IVCO", label: "COTE D`IVOIRE" },
    { value: "HRV", label: "CROATIA" },
    { value: "CUBA", label: "CUBA" },
    { value: "CUR", label: "CURACAO" },
    { value: "CYPR", label: "CYPRUS" },
    { value: "CZEC", label: "CZECH REPUBLIC" },
    { value: "DEN", label: "DENMARK" },
    { value: "DJI", label: "DJIBOUTI" },
    { value: "DOMN", label: "DOMINICA" },
    { value: "DOMR", label: "DOMINICAN REPUBLIC" },
    { value: "ECUA", label: "ECUADOR" },
    { value: "EGYP", label: "EGYPT" },
    { value: "ELSL", label: "EL SALVADOR" },
    { value: "EGN", label: "EQUATORIAL GUINEA" },
    { value: "ERI", label: "ERITREA" },
    { value: "EST", label: "ESTONIA" },
    { value: "SZLD", label: "ESWATINI" },
    { value: "ETH", label: "ETHIOPIA" },
    { value: "FKLI", label: "FALKLAND ISLANDS" },
    { value: "FRO", label: "FAROE ISLANDS" },
    { value: "FIJI", label: "FIJI" },
    { value: "FIN", label: "FINLAND" },
    { value: "FRAN", label: "FRANCE" },
    { value: "FPOL", label: "FRENCH POLYNESIA" },
    { value: "FSAT", label: "FRENCH SOUTHERN AND ANTARCTIC TERRITORIES" },
    { value: "GABN", label: "GABON" },
    { value: "GAM", label: "GAMBIA, THE" },
    { value: "XGZ", label: "GAZA STRIP" },
    { value: "GEO", label: "GEORGIA" },
    { value: "GER", label: "GERMANY" },
    { value: "GHAN", label: "GHANA" },
    { value: "GIB", label: "GIBRALTAR" },
    { value: "GRC", label: "GREECE" },
    { value: "GRLD", label: "GREENLAND" },
    { value: "GREN", label: "GRENADA" },
    { value: "GUAM", label: "GUAM" },
    { value: "GUAT", label: "GUATEMALA" },
    { value: "GNEA", label: "GUINEA" },
    { value: "GUIB", label: "GUINEA - BISSAU" },
    { value: "GUY", label: "GUYANA" },
    { value: "HAT", label: "HAITI" },
    { value: "HMD", label: "HEARD AND MCDONALD ISLANDS" },
    { value: "VAT", label: "HOLY SEE (VATICAN CITY)" },
    { value: "HOND", label: "HONDURAS" },
    { value: "HOKO", label: "HONG KONG BNO" },
    { value: "HNK", label: "HONG KONG SAR" },
    { value: "XHI", label: "HOWLAND ISLAND" },
    { value: "HUNG", label: "HUNGARY" },
    { value: "ICLD", label: "ICELAND" },
    { value: "XIR", label: "IN THE AIR" },
    { value: "IND", label: "INDIA" },
    { value: "IDSA", label: "INDONESIA" },
    { value: "IRAN", label: "IRAN" },
    { value: "IRAQ", label: "IRAQ" },
    { value: "IRE", label: "IRELAND" },
    { value: "ISRL", label: "ISRAEL" },
    { value: "ITLY", label: "ITALY" },
    { value: "JAM", label: "JAMAICA" },
    { value: "JPN", label: "JAPAN" },
    { value: "JRSM", label: "JERUSALEM" },
    { value: "JORD", label: "JORDAN" },
    { value: "KAZ", label: "KAZAKHSTAN" },
    { value: "KENY", label: "KENYA" },
    { value: "KIRI", label: "KIRIBATI" },
    { value: "PRK", label: "KOREA, DEMOCRATIC REPUBLIC OF (NORTH)" },
    { value: "KOR", label: "KOREA, REPUBLIC OF (SOUTH)" },
    { value: "KSV", label: "KOSOVO" },
    { value: "KUWT", label: "KUWAIT" },
    { value: "KGZ", label: "KYRGYZSTAN" },
    { value: "LAOS", label: "LAOS" },
    { value: "LATV", label: "LATVIA" },
    { value: "LEBN", label: "LEBANON" },
    { value: "LES", label: "LESOTHO" },
    { value: "LIBR", label: "LIBERIA" },
    { value: "LBYA", label: "LIBYA" },
    { value: "LCHT", label: "LIECHTENSTEIN" },
    { value: "LITH", label: "LITHUANIA" },
    { value: "LXM", label: "LUXEMBOURG" },
    { value: "MAC", label: "MACAU" },
    { value: "MKD", label: "MACEDONIA, NORTH" },
    { value: "MADG", label: "MADAGASCAR" },
    { value: "MALW", label: "MALAWI" },
    { value: "MLAS", label: "MALAYSIA" },
    { value: "MLDI", label: "MALDEN ISLAND" },
    { value: "MLDV", label: "MALDIVES" },
    { value: "MALI", label: "MALI" },
    { value: "MLTA", label: "MALTA" },
    { value: "RMI", label: "MARSHALL ISLANDS" },
    { value: "MAUR", label: "MAURITANIA" },
    { value: "MRTS", label: "MAURITIUS" },
    { value: "MYT", label: "MAYOTTE" },
    { value: "AGS", label: "MEXICO - AGUASCALIENTES" },
    { value: "BC", label: "MEXICO - BAJA CALIFORNIA NORTE" },
    { value: "BCSR", label: "MEXICO - BAJA CALIFORNIA SUR" },
    { value: "CAMP", label: "MEXICO - CAMPECHE" },
    { value: "CHIS", label: "MEXICO - CHIAPAS" },
    { value: "CHIH", label: "MEXICO - CHIHUAHUA" },
    { value: "COAH", label: "MEXICO - COAHUILA" },
    { value: "COLI", label: "MEXICO - COLIMA" },
    { value: "DF", label: "MEXICO - DISTRITO FEDERAL" },
    { value: "DGO", label: "MEXICO - DURANGO" },
    { value: "GTO", label: "MEXICO - GUANAJUATO" },
    { value: "GRO", label: "MEXICO - GUERRERO" },
    { value: "HGO", label: "MEXICO - HIDALGO" },
    { value: "JAL", label: "MEXICO - JALISCO" },
    { value: "MCH", label: "MEXICO - MICHOACAN" },
    { value: "MOR", label: "MEXICO - MORELOS" },
    { value: "NAY", label: "MEXICO - NAYARIT" },
    { value: "NL", label: "MEXICO - NUEVO LEON" },
    { value: "OAX", label: "MEXICO - OAXACA" },
    { value: "PUE", label: "MEXICO - PUEBLA" },
    { value: "QRO", label: "MEXICO - QUERETARO" },
    { value: "QROO", label: "MEXICO - QUINTANA ROO" },
    { value: "SLP", label: "MEXICO - SAN LUIS POTOSI" },
    { value: "SIN", label: "MEXICO - SINALOA" },
    { value: "SON", label: "MEXICO - SONORA" },
    { value: "MXCO", label: "MEXICO - STATE OF MEXICO" },
    { value: "TAB", label: "MEXICO - TABASCO" },
    { value: "TAMP", label: "MEXICO - TAMAULIPAS" },
    { value: "TLAX", label: "MEXICO - TLAXCALA" },
    { value: "VER", label: "MEXICO - VERACRUZ" },
    { value: "YUC", label: "MEXICO - YUCATAN" },
    { value: "ZAC", label: "MEXICO - ZACATECAS" },
    { value: "FSM", label: "MICRONESIA" },
    { value: "MDWI", label: "MIDWAY ISLANDS" },
    { value: "MLD", label: "MOLDOVA" },
    { value: "MON", label: "MONACO" },
    { value: "MONG", label: "MONGOLIA" },
    { value: "MTG", label: "MONTENEGRO" },
    { value: "MONT", label: "MONTSERRAT" },
    { value: "MORO", label: "MOROCCO" },
    { value: "MOZ", label: "MOZAMBIQUE" },
    { value: "NAMB", label: "NAMIBIA" },
    { value: "NAU", label: "NAURU" },
    { value: "NEP", label: "NEPAL" },
    { value: "NETH", label: "NETHERLANDS" },
    { value: "NCAL", label: "NEW CALEDONIA" },
    { value: "NZLD", label: "NEW ZEALAND" },
    { value: "NIC", label: "NICARAGUA" },
    { value: "NIR", label: "NIGER" },
    { value: "NRA", label: "NIGERIA" },
    { value: "NIUE", label: "NIUE" },
    { value: "NFK", label: "NORFOLK ISLAND" },
    { value: "MNP", label: "NORTH MARIANA ISLANDS" },
    { value: "NIRE", label: "NORTHERN IRELAND" },
    { value: "NORW", label: "NORWAY" },
    { value: "OMAN", label: "OMAN" },
    { value: "PKST", label: "PAKISTAN" },
    { value: "PALA", label: "PALAU" },
    { value: "PLMR", label: "PALMYRA ATOLL" },
    { value: "PAN", label: "PANAMA" },
    { value: "PNG", label: "PAPUA NEW GUINEA" },
    { value: "PARA", label: "PARAGUAY" },
    { value: "PERU", label: "PERU" },
    { value: "PHIL", label: "PHILIPPINES" },
    { value: "PITC", label: "PITCAIRN ISLANDS" },
    { value: "POL", label: "POLAND" },
    { value: "PORT", label: "PORTUGAL" },
    { value: "PR", label: "PUERTO RICO" },
    { value: "QTAR", label: "QATAR" },
    { value: "ROM", label: "ROMANIA" },
    { value: "RUS", label: "RUSSIA" },
    { value: "RWND", label: "RWANDA" },
    { value: "MAF", label: "SAINT MARTIN" },
    { value: "WSAM", label: "SAMOA" },
    { value: "SMAR", label: "SAN MARINO" },
    { value: "STPR", label: "SAO TOME AND PRINCIPE" },
    { value: "SARB", label: "SAUDI ARABIA" },
    { value: "SENG", label: "SENEGAL" },
    { value: "SBA", label: "SERBIA" },
    { value: "SEYC", label: "SEYCHELLES" },
    { value: "SLEO", label: "SIERRA LEONE" },
    { value: "SING", label: "SINGAPORE" },
    { value: "STM", label: "SINT MAARTEN" },
    { value: "SVK", label: "SLOVAKIA" },
    { value: "SVN", label: "SLOVENIA" },
    { value: "SLMN", label: "SOLOMON ISLANDS" },
    { value: "SOMA", label: "SOMALIA" },
    { value: "SAFR", label: "SOUTH AFRICA" },
    { value: "SGS", label: "SOUTH GEORGIA AND THE SOUTH SANDWICH ISLAND" },
    { value: "SSDN", label: "SOUTH SUDAN" },
    { value: "SPN", label: "SPAIN" },
    { value: "SRL", label: "SRI LANKA" },
    { value: "STBR", label: "ST. BARTHELEMY" },
    { value: "SHEL", label: "ST. HELENA" },
    { value: "STCN", label: "ST. KITTS AND NEVIS" },
    { value: "SLCA", label: "ST. LUCIA" },
    { value: "SPMI", label: "ST. PIERRE AND MIQUELON" },
    { value: "STVN", label: "ST. VINCENT AND THE GRENADINES" },
    { value: "SUDA", label: "SUDAN" },
    { value: "SURM", label: "SURINAME" },
    { value: "SJM", label: "SVALBARD" },
    { value: "SWDN", label: "SWEDEN" },
    { value: "SWTZ", label: "SWITZERLAND" },
    { value: "SYR", label: "SYRIA" },
    { value: "TWAN", label: "TAIWAN" },
    { value: "TJK", label: "TAJIKISTAN" },
    { value: "TAZN", label: "TANZANIA" },
    { value: "THAI", label: "THAILAND" },
    { value: "TMOR", label: "TIMOR-LESTE" },
    { value: "TOGO", label: "TOGO" },
    { value: "TKL", label: "TOKELAU" },
    { value: "TONG", label: "TONGA" },
    { value: "TRIN", label: "TRINIDAD AND TOBAGO" },
    { value: "TNSA", label: "TUNISIA" },
    { value: "TRKY", label: "TURKEY" },
    { value: "TKM", label: "TURKMENISTAN" },
    { value: "TCIS", label: "TURKS AND CAICOS ISLANDS" },
    { value: "TUV", label: "TUVALU" },
    { value: "UGAN", label: "UGANDA" },
    { value: "UKR", label: "UKRAINE" },
    { value: "UAE", label: "UNITED ARAB EMIRATES" },
    { value: "GRBR", label: "UNITED KINGDOM" },
    { value: "USA", label: "UNITED STATES OF AMERICA" },
    { value: "URU", label: "URUGUAY" },
    { value: "UZB", label: "UZBEKISTAN" },
    { value: "VANU", label: "VANUATU" },
    { value: "VENZ", label: "VENEZUELA" },
    { value: "VTNM", label: "VIETNAM" },
    { value: "VI", label: "VIRGIN ISLANDS (U.S.)" },
    { value: "BRVI", label: "VIRGIN ISLANDS, BRITISH" },
    { value: "WKI", label: "WAKE ISLAND" },
    { value: "WAFT", label: "WALLIS AND FUTUNA ISLANDS" },
    { value: "XWB", label: "WEST BANK" },
    { value: "SSAH", label: "WESTERN SAHARA" },
    { value: "YEM", label: "YEMEN" },
    { value: "ZAMB", label: "ZAMBIA" },
    { value: "ZIMB", label: "ZIMBABWE" },
];


// Função que renderiza a etapa de Dados Pessoais
export function InformacoesPessoaisCanada({ formData, handleInputChange, errors, addEntry, removeEntry, }) {

    return (
        <div
        // style={{width: "100%"}}
        >
            <h2>Dados Pessoais</h2>
            <div>
                <label>Nome:
                    {formData.nome && (
                        <span style={{ fontSize: "0.9em", color: "#555", paddingLeft: "10px" }}>
                            {formData.nome.length} / 33
                        </span>
                    )}
                </label>
                <InputField
                    errors={errors}
                    type="text"
                    name="nome"
                    value={formData.nome}
                    onChange={handleInputChange}
                    maxLength={33}
                />
                {/* {errors.nome && <span>{errors.nome}</span>} */}
            </div>
            <div>
                <label>Sobrenome:
                    {formData.sobrenome && (
                        <span style={{ fontSize: "0.9em", color: "#555", paddingLeft: "10px" }}>
                            {formData.sobrenome.length} / 33
                        </span>
                    )}
                </label>
                <InputField
                    errors={errors}
                    type="text"
                    name="sobrenome"
                    value={formData.sobrenome}
                    onChange={handleInputChange}
                    maxLength={33}
                />
                {/* {errors.sobrenome && <span>{errors.sobrenome}</span>} */}
            </div>
            <div>
                <div>
                    <label>Sexo:</label>
                </div>
                <select
                    name="sexo"
                    value={formData.sexo}
                    onChange={handleInputChange}
                >
                    <option value="">- Selecione um -</option>
                    <option value="M">Homem</option>
                    <option value="F">Mulher</option>
                </select>
            </div>
            <div>
                <label>Cidade de Nascimento:
                    {formData.cidadeNascimento && (
                        <span style={{ fontSize: "0.9em", color: "#555", paddingLeft: "10px" }}>
                            {formData.cidadeNascimento.length} / 20
                        </span>
                    )}
                </label>
                <InputField
                    errors={errors}
                    type="text"
                    name="cidadeNascimento"
                    value={formData.cidadeNascimento}
                    onChange={handleInputChange}
                    maxLength={20}
                />
            </div>
            <div>
                <label>Estado de Nascimento:</label>
                <InputField
                    errors={errors}
                    type="text"
                    name="estadoNascimento"
                    value={formData.estadoNascimento}
                    onChange={handleInputChange}
                />
            </div>
            <div>
                <label>Data de Nascimento:</label>
                <InputField
                    errors={errors}
                    type="date"
                    name="dataNascimento"
                    value={formData.dataNascimento}
                    onChange={handleInputChange}
                />
            </div>
            <div>
                <label>CPF do solicitante:
                </label>
                <InputField
                    errors={errors}
                    type="text"
                    name="cpf"
                    value={formData.cpf}
                    onChange={handleInputChange}
                    maxLength={14}
                />
            </div>
            <div>
                <div>
                    <label>Estado Civil:</label>
                </div>
                <select
                    name="estadoCivil"
                    value={formData.estadoCivil}
                    onChange={handleInputChange}
                >
                    <option value="">- Selecione um -</option>
                    <option value="S">Solteiro(a)</option>
                    <option value="M">Casado(a)</option>
                    <option value="C">União Estável/Parceria Civil/União Doméstica</option>
                    <option value="W">Viúvo(a)</option>
                    <option value="D">Divorciado(a)</option>
                    <option value="L">Separado(a) Legalmente</option>
                    <option value="O">Outro</option>
                </select>
            </div>
            {(formData.estadoCivil === 'M' || formData.estadoCivil === 'C' || formData.estadoCivil === 'W') && (
                <div>
                    <h3>Informações sobre Cônjuge Atual</h3>
                    <label>Data do casamento:</label>
                    <InputField
                        errors={errors}
                        type="date"
                        name="dataCasamento"
                        value={formData.dataCasamento}
                        onChange={handleInputChange}
                    />
                    <label>Nome (cônjuge):</label>
                    <InputField
                        errors={errors}
                        type="text"
                        name="nomeConjuge"
                        value={formData.nomeConjuge}
                        onChange={handleInputChange}
                    />
                    <label>Sobrenome (cônjuge):</label>
                    <InputField
                        errors={errors}
                        type="text"
                        name="sobreNomeConjuge"
                        value={formData.sobreNomeConjuge}
                        onChange={handleInputChange}
                    />
                    <label>Data de nascimento (cônjuge):</label>
                    <InputField
                        errors={errors}
                        type="date"
                        name="dataNascimentoConjuge"
                        value={formData.dataNascimentoConjuge}
                        onChange={handleInputChange}
                    />
                    <label>Local de nascimento (cônjuge):</label>
                    <InputField
                        errors={errors}
                        type="text"
                        name="localNascimentoConjuge"
                        value={formData.localNascimentoConjuge}
                        onChange={handleInputChange}
                    />
                    <label>Endereço (cônjuge):</label>
                    <InputField
                        errors={errors}
                        type="text"
                        name="enderecoConjuge"
                        value={formData.enderecoConjuge}
                        onChange={handleInputChange}
                    />
                </div>
            )}
            {(formData.estadoCivil === 'D' || formData.estadoCivil === 'L') && (
                <div>
                    <h3>Informe sobre a separação</h3>
                    {formData.divorcios.map((divorcio, index) => (
                        <div key={index}>
                            <h4>{index + 1}° Separação</h4>
                            <label>Nome:</label>
                            <InputField
                                errors={errors}
                                type="text"
                                name={`nomeDivorcio-${index}`}
                                value={divorcio.nome}
                                onChange={(e) => handleInputChange(e, index, 'divorcios', 'nome')}
                            />
                            <label>Sobrenome:</label>
                            <InputField
                                errors={errors}
                                type="text"
                                name={`sobreNomeDivorcio-${index}`}
                                value={divorcio.sobreNome}
                                onChange={(e) => handleInputChange(e, index, 'divorcios', 'sobreNome')}
                            />
                            <label>Data de nascimento:</label>
                            <InputField
                                errors={errors}
                                type="date"
                                name={`dataNascimentoDivorcio-${index}`}
                                value={divorcio.dataNascimento}
                                onChange={(e) => handleInputChange(e, index, 'divorcios', 'dataNascimento')}
                            />
                            <label>Local de nascimento:</label>
                            <InputField
                                errors={errors}
                                type="text"
                                name={`localNascimentoDivorcio-${index}`}
                                value={divorcio.localNascimento}
                                onChange={(e) => handleInputChange(e, index, 'divorcios', 'localNascimento')}
                            />
                            <label>Data do casamento:</label>
                            <InputField
                                errors={errors}
                                type="date"
                                name={`dataCasamentoDivorcio-${index}`}
                                value={divorcio.dataCasamento}
                                onChange={(e) => handleInputChange(e, index, 'divorcios', 'dataCasamento')}
                            />
                            <label>Data do divórcio/separação:</label>
                            <InputField
                                errors={errors}
                                type="date"
                                name={`dataDivorcio-${index}`}
                                value={divorcio.dataDivorcio}
                                onChange={(e) => handleInputChange(e, index, 'divorcios', 'dataDivorcio')}
                            />
                            <label>Motivo:</label>
                            <textarea
                                className={styles.textareaForm}
                                name={`motivoDivorcio-${index}`}
                                value={divorcio.motivo}
                                onChange={(e) => handleInputChange(e, index, 'divorcios', 'motivo')}
                            />
                            <button
                                style={{ color: " red", backgroundColor: '#ffffff00', marginBottom: "20px", padding: "5px", border: "solid 1px  red", borderRadius: "20px" }}
                                type="button" onClick={() => removeEntry('divorcios', index)}>- Remover Divórcio</button>
                        </div>
                    ))}
                    <button type="button" onClick={() => addEntry('divorcios')}>+ Adicionar Divórcio</button>
                </div>
            )}
            <label style={{ width: "100%" }}>Já fez alguma alteração no nome ou sobrenome?</label>
            <div
            // style={{display: "flex"}}
            >
                <div
                // style={{width: "50%"}}
                >
                    <InputField
                        errors={errors}
                        style={{ width: "auto" }}
                        type="radio"
                        name="alteracaoNome"
                        value="nao"
                        checked={formData.alteracaoNome === 'nao'}
                        onChange={handleInputChange}
                    />
                    <label>Não</label>
                </div>
                <div
                // style={{width: "50%"}}
                >
                    <InputField
                        errors={errors}
                        style={{ width: "auto" }}
                        type="radio"
                        name="alteracaoNome"
                        value="sim"
                        checked={formData.alteracaoNome === 'sim'}
                        onChange={handleInputChange}
                    />
                    <label>Sim</label>
                </div>
                {formData.alteracaoNome === 'sim' && (
                    <div>
                        <div>
                            <label>nome anterior</label>
                            <InputField
                                errors={errors}
                                type="text"
                                name="detalhesAlteracaoNome"
                                value={formData.detalhesAlteracaoNome}
                                onChange={handleInputChange}
                            />
                        </div>
                        <div>
                            <label>sobrenome anterior</label>
                            <InputField
                                errors={errors}
                                type="text"
                                name="detalhesAlteracaoSobreNome"
                                value={formData.detalhesAlteracaoSobreNome}
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>
                )}
            </div>
            {/* <div> */}
            <div>
                <label>Você possui ou já possuiu outra nacionalidade além da brasileira?</label>
                <div>
                    <InputField
                        errors={errors}
                        style={{ width: "auto" }}
                        type="radio"
                        name="possuiOutraNacionalidade"
                        value="nao"
                        checked={formData.possuiOutraNacionalidade === 'nao'}
                        onChange={handleInputChange}
                    />
                    <label>Não</label>
                </div>
                <div>
                    <InputField
                        errors={errors}
                        style={{ width: "auto" }}
                        type="radio"
                        name="possuiOutraNacionalidade"
                        value="sim"
                        checked={formData.possuiOutraNacionalidade === 'sim'}
                        onChange={handleInputChange}
                    />
                    <label>Sim</label>
                </div>
                {formData.possuiOutraNacionalidade === 'sim' && (
                    <div>
                        <label>Especifique a nacionalidade:</label>
                        <select name="nacionalidade" value={formData.nacionalidade} onChange={handleInputChange}>
                            <option value="">- Selecione um país -</option>
                            {nacionalidades.map((estado) => (
                                <option key={estado.value} value={estado.value}>
                                    {estado.label}
                                </option>
                            ))}
                        </select>
                        <label>Você possui passaporte para o outro país/região de origem (nacionalidade) acima? </label>
                        <div>
                            <InputField
                                errors={errors}
                                style={{ width: "auto" }}
                                type="radio"
                                name="possuiOutraNacionalidadePassaporte"
                                value="nao"
                                checked={formData.possuiOutraNacionalidadePassaporte === 'nao'}
                                onChange={handleInputChange}
                            />
                            <label>Não</label>
                        </div>
                        <div>
                            <InputField
                                errors={errors}
                                style={{ width: "auto" }}
                                type="radio"
                                name="possuiOutraNacionalidadePassaporte"
                                value="sim"
                                checked={formData.possuiOutraNacionalidadePassaporte === 'sim'}
                                onChange={handleInputChange}
                            />
                            <label>Sim</label>
                        </div>
                        {formData.possuiOutraNacionalidadePassaporte === 'sim' && (
                            <div>
                                <label>Número do Passaporte (ex: GF123456):</label>
                                <InputField
                                    errors={errors}
                                    type="text"
                                    name="numeroPassaporteOutraNacionalidade"
                                    value={formData.numeroPassaporteOutraNacionalidade}
                                    onChange={handleInputChange}
                                />
                            </div>
                        )}
                    </div>
                )}
            </div>
            {/* Continue com os outros campos */}
        </div>
    );
}




// Função que renderiza a etapa de Endereço e Contato
export function EnderecoEContatoCanada({ formData, handleInputChange, addEntry, removeEntry, errors }) {
    // Prefixos por plataforma
    const SOCIAL_PREFIX = {
        SONE: "",
        INST: "https://instagram.com/",
        FCBK: "https://facebook.com/",
        LINK: "https://linkedin.com/in/",
        TWIT: "https://twitter.com/",
        YTUB: "https://youtube.com/@",
        TKTK: "https://tiktok.com/@",
        OUTR: "https://",
        SITE: "https://",
        ASKF: "https://ask.fm/",
        DUBN: "https://www.douban.com/people/",
        FLKR: "https://flickr.com/people/",
        GOGL: "https://plus.google.com/",   // legado
        MYSP: "https://myspace.com/",
        PTST: "https://pinterest.com/",
        QZNE: "https://qzone.qq.com/",
        RDDT: "https://reddit.com/user/",
        SWBO: "https://weibo.com/",
        TWBO: "https://t.qq.com/",          // legado
        TUMB: "https://tumblr.com/",
        TWOO: "https://twoo.com/",
        VINE: "https://vine.co/",           // legado
        VKON: "https://vk.com/",
        YUKU: "https://youku.com/",
        NONE: ""
    };

    function buildSocialUrl(prefix, rawUser) {
        const p = prefix || "";

        // normaliza o que o usuário digitou/colou
        let user = (rawUser || "").trim();

        // Se o prefixo termina com "@", remove arrobas repetidas no início do username
        const endsWithAt = p.endsWith("@");
        if (endsWithAt) {
            user = user.replace(/^@+/, "");
        }

        // Para prefixos com "/" (a maioria), remova barras extras no início do username
        if (!endsWithAt) {
            user = user.replace(/^\/+/, "");
        }

        // CASO ESPECIAL: prefixo genérico "https://"
        // - remove qualquer http(s):// do que o usuário digitou
        // - remove barras duplas
        if (p === "https://") {
            user = user.replace(/^https?:\/\//i, ""); // remove protocolo
            user = user.replace(/^\/+/, "");          // remove barras iniciais
            user = user.replace(/\/{2,}/g, "/");      // colapsa barras repetidas
            return p + user;
        }

        // Regra geral: evita duplicar o prefixo se o usuário colou a URL completa
        if (user.toLowerCase().startsWith(p.toLowerCase())) {
            user = user.slice(p.length);
            user = user.replace(/^[@/]+/, "");
        }

        // Garante que o prefixo que termina em "/" fique com apenas uma "/"
        let safePrefix = p;
        if (!endsWithAt) {
            safePrefix = p.replace(/\/+$/, "/");
        }

        return safePrefix + user;
    }


    function extractUsernameFromFull(prefix, full) {
        if (!full) return "";
        let s = full.trim();

        // Para prefixo genérico, remova http(s):// primeiro
        if ((prefix || "") === "https://") {
            s = s.replace(/^https?:\/\//i, "");
        }

        // Remove o prefixo específico (se presente)
        if (prefix) {
            s = s.replace(new RegExp("^" + prefix.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "i"), "");
        }

        // Limpa @ ou / iniciais duplicados
        s = s.replace(/^[@/]+/, "");

        return s;
    }


    // (opcional) se quiser mostrar prevUrl em cada option
    const socialMediaOptions = [
        { value: "SONE", label: "- Select One -" },
        { value: "INST", label: "INSTAGRAM" },
        { value: "FCBK", label: "FACEBOOK" },
        { value: "LINK", label: "LINKEDIN" },
        { value: "TWIT", label: "TWITTER (X)" },
        { value: "YTUB", label: "YOUTUBE" },
        { value: "TKTK", label: "TIKTOK" },
        { value: "OUTR", label: "OUTRA" },
        { value: "SITE", label: "SITE PROPRIO" },
        { value: "ASKF", label: "ASK.FM" },
        { value: "DUBN", label: "DOUBAN" },
        { value: "FLKR", label: "FLICKR" },
        { value: "GOGL", label: "GOOGLE+" },
        { value: "MYSP", label: "MYSPACE" },
        { value: "PTST", label: "PINTEREST" },
        { value: "QZNE", label: "QZONE (QQ)" },
        { value: "RDDT", label: "REDDIT" },
        { value: "SWBO", label: "SINA WEIBO" },
        { value: "TWBO", label: "TENCENT WEIBO" },
        { value: "TUMB", label: "TUMBLR" },
        { value: "TWOO", label: "TWOO" },
        { value: "VINE", label: "VINE" },
        { value: "VKON", label: "VKONTAKTE (VK)" },
        { value: "YUKU", label: "YOUKU" },
        { value: "NONE", label: "NONE" }
    ];


    return (
        <div>
            <h2>Endereço e Contato</h2>
            <div>
                <label>Endereço:
                    {formData.endereco && (
                        <span style={{ fontSize: "0.9em", color: "#555", paddingLeft: "10px" }}>
                            {formData.endereco.length} / 40
                        </span>
                    )}
                </label>
                <InputField
                    errors={errors}
                    type="text"
                    name="endereco"
                    value={formData.endereco}
                    onChange={handleInputChange}
                    maxLength={40}
                />
            </div>
            <div>
                <label>Bairro:
                    {formData.bairro && (
                        <span style={{ fontSize: "0.9em", color: "#555", paddingLeft: "10px" }}>
                            {formData.bairro.length} / 40
                        </span>
                    )}
                </label>
                <InputField
                    errors={errors}
                    type="text"
                    name="bairro"
                    value={formData.bairro}
                    onChange={handleInputChange}
                    maxLength={40}
                />
            </div>
            <div>
                <label>Cidade:
                    {formData.cidadeEstado && (
                        <span style={{ fontSize: "0.9em", color: "#555", paddingLeft: "10px" }}>
                            {formData.cidadeEstado.length} / 20
                        </span>
                    )}
                </label>
                <InputField
                    errors={errors}
                    type="text"
                    name="cidadeEstado"
                    value={formData.cidadeEstado}
                    onChange={handleInputChange}
                    maxLength={20}
                />
            </div>
            <div>
                <div>
                    <label>Estado:</label>

                </div>
                <select name="estadoCasa" value={formData.estadoCasa} onChange={handleInputChange}>
                    <option value="">- Selecione um estado -</option>
                    {estadosBrasileiros.map((estado) => (
                        <option key={estado.value} value={estado.value}>
                            {estado.label}
                        </option>
                    ))}
                </select>
            </div>
            <div>
                <div>
                    <label>CEP:</label>
                </div>
                <InputField
                    errors={errors}
                    type="text"
                    name="cep"
                    value={formData.cep}
                    onChange={handleInputChange}
                />
            </div>
            <div>
                <h3>CONTATOS DE CELULAR:</h3>
                <div className={styles.obsForm}>
                    <p>Insira todos os seus números utilizados (pessoal e de trabalho)</p>
                </div>

                {formData.telefones.map((telefone, index) => (
                    <div key={index}>
                        <InputField
                            errors={errors}
                            type="text"
                            name={`telefone-${index}`}
                            value={telefone}
                            onChange={(e) => {
                                const onlyNumbers = e.target.value.replace(/\D/g, '');
                                handleInputChange(
                                    {
                                        target: {
                                            name: e.target.name,
                                            value: onlyNumbers,
                                        },
                                    },
                                    index,
                                    'telefones'
                                );
                            }}
                            maxLength={15}
                            inputMode="numeric"
                            pattern="[0-9]*"
                            placeholder={`Telefone ${index + 1}`}
                        />

                    </div>
                ))}
                {formData.telefones.length < 3 && (
                    <button type="button" onClick={() => addEntry('telefones')}>+ Adicionar Telefone</button>
                )}
            </div>
            <div>
                <h3>E-MAILS UTILIZADOS:</h3>
                <div className={styles.obsForm}>
                    <p>Insira todos os seus e-mails utilizados (pessoal e de trabalho)</p>
                </div>
                {formData.emails.map((email, index) => (
                    <div key={index}>
                        <InputField
                            errors={errors}
                            type="email"
                            name={`email-${index}`}
                            value={email}
                            onChange={(e) => handleInputChange(e, index, 'emails')}
                            placeholder={`E-mail ${index + 1}`}
                            style={{
                                border: errors[`email-${index}`] ? '1px solid red' : undefined
                            }}
                        />
                        {errors[`email-${index}`] && (
                            <span style={{ color: 'red', fontSize: '0.8em' }}>
                                {errors[`email-${index}`]}
                            </span>
                        )}
                    </div>
                ))}

                {formData.emails.length < 3 && (
                    <button type="button" onClick={() => addEntry('emails')}>+ Adicionar E-mail</button>
                )}
            </div>










            <div>
                <h3>Mídias Sociais usadas nos últimos anos:</h3>

                {formData.redesSociais.map((rede, index) => {
                    const prefix = SOCIAL_PREFIX[rede.plataforma] || "";
                    const showUserInput =
                        rede.plataforma && rede.plataforma !== "SONE" && rede.plataforma !== "NONE";

                    const placeholder =
                        (prefix || "https://") + (prefix.endsWith("@") ? "usuario" : "usuario");

                    return (
                        <div key={index} style={{ display: "flex", flexDirection: "column", gap: 10, width: "100%" }}>
                            {/* Linha 1: Label + Select (label mínimo, select ocupa o resto) */}
                            <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
                                <label style={{ marginRight: 10, whiteSpace: "nowrap" }}>Rede Social:</label>
                                <select
                                    style={{ flex: 1 }}
                                    name={`redeSocial-${index}`}
                                    value={rede.plataforma}
                                    onChange={(e) => {
                                        const newPlatform = e.target.value;
                                        const newPrefix = SOCIAL_PREFIX[newPlatform] || "";

                                        // tenta preservar o username anterior
                                        let prevUser = "";
                                        if (rede.usuario) {
                                            const oldPrefix = SOCIAL_PREFIX[rede.plataforma] || "";
                                            prevUser = (rede.usuario || "")
                                                .replace(oldPrefix, "")
                                                .replace(/^[@/]+/, "");
                                        }

                                        const finalUrl = buildSocialUrl(newPrefix, prevUser);

                                        // atualiza URL final
                                        handleInputChange(
                                            { target: { name: `usuarioRede-${index}`, value: finalUrl } },
                                            index,
                                            "redesSociais",
                                            "usuario"
                                        );

                                        // atualiza plataforma
                                        handleInputChange(e, index, "redesSociais", "plataforma");
                                    }}
                                >
                                    {socialMediaOptions.map((option) => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {/* Linha 2: só aparece DEPOIS de selecionar uma rede; sem label, 100% de largura.
            Input group com prefixo fixo + input de username na MESMA linha e centralizados */}
                            {showUserInput && (
                                <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
                                    <div
                                        style={{
                                            width: "100%",
                                            display: "grid",
                                            gridTemplateColumns: "max-content 1fr",
                                            border: "1px solid #ccc",
                                            borderRadius: 8,
                                            overflow: "hidden",
                                            height: 40,                 // altura única p/ parecer um input só
                                            boxSizing: "border-box",
                                            background: "#fff"
                                        }}
                                    >
                                        {/* Prefixo fixo (não editável) */}
                                        <span
                                            aria-hidden="true"
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                padding: "0 12px",
                                                fontFamily: "monospace",
                                                fontSize: 14,
                                                background: "#f6f7f9",
                                                borderRight: "1px solid #e5e7eb",
                                                whiteSpace: "nowrap",
                                                color: "#555",
                                                userSelect: "none",
                                                pointerEvents: "none"      // não recebe foco/click
                                            }}
                                        >
                                            {prefix || "https://"}
                                        </span>

                                        {/* Campo somente do username (ocupa o restante da linha) */}
                                        <input
                                            style={{
                                                width: "100%",
                                                border: "none",
                                                outline: "none",
                                                padding: "0 12px",
                                                fontSize: 14,
                                                lineHeight: 1,
                                                height: "100%",
                                                boxSizing: "border-box"
                                            }}
                                            type="text"
                                            name={`usuarioRedeUsername-${index}`}
                                            value={extractUsernameFromFull(prefix, rede.usuario)}
                                            onChange={(e) => {
                                                const finalUrl = buildSocialUrl(prefix, e.target.value);
                                                handleInputChange(
                                                    { target: { name: `usuarioRede-${index}`, value: finalUrl } },
                                                    index,
                                                    "redesSociais",
                                                    "usuario"
                                                );
                                            }}
                                            onPaste={(e) => {
                                                const text = (e.clipboardData?.getData("text") || "").trim();

                                                // Normaliza o texto colado para não duplicar https://
                                                let pasted = text;
                                                if (prefix === "https://") {
                                                    pasted = pasted.replace(/^https?:\/\//i, "");
                                                    pasted = pasted.replace(/^\/+/, "");
                                                } else {
                                                    // se colou exatamente com o prefixo da rede, remove-o para ficar só o username
                                                    if (pasted.toLowerCase().startsWith(prefix.toLowerCase())) {
                                                        pasted = pasted.slice(prefix.length).replace(/^[@/]+/, "");
                                                    }
                                                }

                                                e.preventDefault();
                                                const finalUrl = buildSocialUrl(prefix, pasted);
                                                handleInputChange(
                                                    { target: { name: `usuarioRede-${index}`, value: finalUrl } },
                                                    index,
                                                    "redesSociais",
                                                    "usuario"
                                                );
                                            }}
                                            placeholder="NomeDeUsuario"
                                            autoComplete="off"
                                            inputMode="text"
                                        />

                                    </div>
                                </div>
                            )}


                            <button
                                style={{
                                    color: "red",
                                    backgroundColor: "transparent",
                                    marginBottom: 20,
                                    padding: 5,
                                    border: "1px solid red",
                                    borderRadius: 20
                                }}
                                type="button"
                                onClick={() => removeEntry("redesSociais", index)}
                            >
                                - Remover
                            </button>
                        </div>
                    );
                })}

                <button type="button" onClick={() => addEntry("redesSociais")}>
                    + Adicionar Rede Social
                </button>
            </div>

        </div>
    );
}

// Função que renderiza a etapa de Dados de Passaporte
export function DadosDePassaporteIdentidade({ formData, handleInputChange, errors }) {
    return (
        <div>
            <h2>Dados de Passaporte</h2>
            <div>
                <label>Data de Emissão:</label>
                <InputField
                    errors={errors}
                    type="date"
                    name="dataEmissaoPassaporte"
                    value={formData.dataEmissaoPassaporte}
                    onChange={handleInputChange}
                />
            </div>
            <div>
                <label>Data de Vencimento:</label>
                <InputField
                    errors={errors}
                    type="date"
                    name="dataExpiracaoPassaporte"
                    value={formData.dataExpiracaoPassaporte}
                    onChange={handleInputChange}
                />
            </div>
            <div>
                <label>Número do Passaporte (ex: GF123456):</label>
                <InputField
                    errors={errors}
                    type="text"
                    name="numeroPassaporte"
                    value={formData.numeroPassaporte}
                    onChange={handleInputChange}
                />
            </div>
            <div>
                <label>Em que cidade foi emitido?</label>
                <InputField
                    errors={errors}
                    type="text"
                    name="cidadeEstadoEmissaoPassaporte"
                    value={formData.cidadeEstadoEmissaoPassaporte}
                    onChange={handleInputChange}
                />
            </div>
            <div>
                <label>Em que Estado foi emitido?</label>
                <select name="EstadoEmissaoPassaporte" value={formData.EstadoEmissaoPassaporte} onChange={handleInputChange}>
                    <option value="">- Selecione um estado -</option>
                    {estadosBrasileiros.map((estado) => (
                        <option key={estado.value} value={estado.value}>
                            {estado.label}
                        </option>
                    ))}
                </select>
            </div>
            <div>
                <label>Você já teve algum passaporte roubado ou perdido?</label>
                <div>
                    <InputField
                        errors={errors}
                        style={{ width: "auto" }}
                        type="radio"
                        name="passaporteRoubadoPerdido"
                        value="nao"
                        checked={formData.passaporteRoubadoPerdido === 'nao'}
                        onChange={handleInputChange}
                    />
                    <label>Não</label>
                </div>
                <div>
                    <InputField
                        errors={errors}
                        style={{ width: "auto" }}
                        type="radio"
                        name="passaporteRoubadoPerdido"
                        value="sim"
                        checked={formData.passaporteRoubadoPerdido === 'sim'}
                        onChange={handleInputChange}
                    />
                    <label>Sim</label>
                </div>
                {formData.passaporteRoubadoPerdido === 'sim' && (
                    <div>
                        <label>Número do Passaporte Perdido:</label>
                        <InputField
                            errors={errors}
                            type="text"
                            name="numeroPassaportePerdido"
                            value={formData.numeroPassaportePerdido}
                            onChange={handleInputChange}
                        />
                        <label>País de Emissão do Passaporte Perdido:</label>
                        <InputField
                            errors={errors}
                            type="text"
                            name="paisEmissaoPassaportePerdido"
                            value={formData.paisEmissaoPassaportePerdido}
                            onChange={handleInputChange}
                        />
                        <label>Explique (caso saiba, informar o número do boletim de ocorrência):</label>
                        <textarea
                            className={styles.textareaForm}
                            name="detalhesPassaportePerdido"
                            value={formData.detalhesPassaportePerdido}
                            onChange={handleInputChange}
                        />
                    </div>
                )}
            </div>





            <h2>Documento de Identidade</h2>
            <div>
                <label>Número da Identidade (ex: 123.456.789.12):</label>
                <InputField
                    errors={errors}
                    type="text"
                    name="numeroIdentidade"
                    value={formData.numeroIdentidade}
                    onChange={handleInputChange}
                />
            </div>
            <div>
                <label>Data de Emissão:</label>
                <InputField
                    errors={errors}
                    type="date"
                    name="dataEmissaoIdentidade"
                    value={formData.dataEmissaoIdentidade}
                    onChange={handleInputChange}
                />
            </div>
            <div>
                <label>Data de Vencimento:</label>
                <InputField
                    errors={errors}
                    type="date"
                    name="dataExpiracaoIdentidade"
                    value={formData.dataExpiracaoIdentidade}
                    onChange={handleInputChange}
                />
            </div>

            <div>
                <label>Em que cidade foi emitido?</label>
                <InputField
                    errors={errors}
                    type="text"
                    name="cidadeEstadoEmissaoIdentidade"
                    value={formData.cidadeEstadoEmissaoIdentidade}
                    onChange={handleInputChange}
                />
            </div>



        </div>
    );
}



// Função que renderiza a etapa de Residência e Vistos nos Canada
// Função que renderiza a etapa de Residência e Vistos nos EUA
export function InformacoesComplementaresCanada({ formData, handleInputChange, addEntry, removeEntry, errors }) {


    return (
        <div>
            <h2>Vistos E Permanências</h2>

            <div>
                <label>Já coletou sua biometria e foto para o processo do visto canadense nos últimos 10 anos? </label>
                <div>
                    <div>
                        <InputField type="radio" style={{ width: "auto" }} name="jacoletouCanada" value="nao" checked={formData.jacoletouCanada === 'nao'} onChange={handleInputChange} label="Não" errors={errors} />
                        <label>Não</label>
                    </div>
                    <div>
                        <InputField type="radio" style={{ width: "auto" }} name="jacoletouCanada" value="sim" checked={formData.jacoletouCanada === 'sim'} onChange={handleInputChange} label="Sim" errors={errors} />
                        <label>Sim</label>
                    </div>
                    {formData.jacoletouCanada === 'sim' && (
                        <InputField name="jacoletouCanadaData" value={formData.jacoletouCanadaData} onChange={handleInputChange} label="Data:" errors={errors} />
                    )}
                </div>
            </div>

            <div>
                <label>Você tem um membro da família que é cidadão canadense ou residente permanente e tem 18 anos ou mais?</label>
                <div>
                    <div>
                        <InputField type="radio" style={{ width: "auto" }} name="temParenteCanadense" value="nao" checked={formData.temParenteCanadense === 'nao'} onChange={handleInputChange} label="Não" errors={errors} />
                        <label>Não</label>
                    </div>
                    <div>
                        <InputField type="radio" style={{ width: "auto" }} name="temParenteCanadense" value="sim" checked={formData.temParenteCanadense === 'sim'} onChange={handleInputChange} label="Sim" errors={errors} />
                        <label>Sim</label>
                    </div>
                    {formData.temParenteCanadense === 'sim' && (
                        <InputField name="quemParenteCanadense" value={formData.quemParenteCanadense} onChange={handleInputChange} label="Quem:" errors={errors} />
                    )}
                </div>
            </div>

            <div>
                <label>Você já morou no Canadá como residente permanente ou imigrante desembarcado?</label>
                <div>
                    <div>
                        <InputField type="radio" style={{ width: "auto" }} name="jaMoraCanada" value="nao" checked={formData.jaMoraCanada === 'nao'} onChange={handleInputChange} label="Não" errors={errors} />
                        <label>Não</label>
                    </div>
                    <div>
                        <InputField type="radio" style={{ width: "auto" }} name="jaMoraCanada" value="sim" checked={formData.jaMoraCanada === 'sim'} onChange={handleInputChange} label="Sim" errors={errors} />
                        <label>Sim</label>
                    </div>
                </div>
            </div>

            <div>
                <label>Você já teve um visto negado do Canadá ou de outro país/território, ou sua entrada foi negada ou foi-lhe ordenado que deixasse algum país ou território?</label>
                <div>
                    <div>
                        <InputField type="radio" style={{ width: "auto" }} name="teveVistoNegadoOutroPais" value="nao" checked={formData.teveVistoNegadoOutroPais === 'nao'} onChange={handleInputChange} label="Não" errors={errors} />
                        <label>Não</label>
                    </div>
                    <div>
                        <InputField type="radio" style={{ width: "auto" }} name="teveVistoNegadoOutroPais" value="sim" checked={formData.teveVistoNegadoOutroPais === 'sim'} onChange={handleInputChange} label="Sim" errors={errors} />
                        <label>Sim</label>
                    </div>
                    {formData.teveVistoNegadoOutroPais === 'sim' && (
                        <textarea name="explicacaoVistoNegadoOutroPais" className={styles.textareaForm} value={formData.explicacaoVistoNegadoOutroPais} onChange={handleInputChange} placeholder="Explicar:" />
                    )}
                </div>
            </div>

            <div>
                <label>Você é um residente permanente legal dos Estados Unidos com um número válido dos Serviços de Cidadania e Imigração dos EUA (USCIS)?</label>
                <div>
                    <div>
                        <InputField type="radio" style={{ width: "auto" }} name="residenteEUA" value="nao" checked={formData.residenteEUA === 'nao'} onChange={handleInputChange} label="Não" errors={errors} />
                        <label>Não</label>
                    </div>
                    <div>
                        <InputField type="radio" style={{ width: "auto" }} name="residenteEUA" value="sim" checked={formData.residenteEUA === 'sim'} onChange={handleInputChange} label="Sim" errors={errors} />
                        <label>Sim</label>
                    </div>
                </div>
            </div>

            <div>
                <label>Nos últimos 10 anos, você possuiu um visto canadense de residente temporário válido?</label>
                <div>
                    <div>
                        <InputField type="radio" style={{ width: "auto" }} name="teveVistoCanada" value="nao" checked={formData.teveVistoCanada === 'nao'} onChange={handleInputChange} label="Não" errors={errors} />
                        <label>Não</label>
                    </div>
                    <div>
                        <InputField type="radio" style={{ width: "auto" }} name="teveVistoCanada" value="sim" checked={formData.teveVistoCanada === 'sim'} onChange={handleInputChange} label="Sim" errors={errors} />
                        <label>Sim</label>
                    </div>
                </div>
            </div>

            <div>
                <label>Você atualmente possui um visto válido de não-imigrante nos EUA? (turista)</label>
                <div>
                    <div>
                        <InputField type="radio" style={{ width: "auto" }} name="vistoValidoEUA" value="nao" checked={formData.vistoValidoEUA === 'nao'} onChange={handleInputChange} label="Não" errors={errors} />
                        <label>Não</label>
                    </div>
                    <div>
                        <InputField type="radio" style={{ width: "auto" }} name="vistoValidoEUA" value="sim" checked={formData.vistoValidoEUA === 'sim'} onChange={handleInputChange} label="Sim" errors={errors} />
                        <label>Sim</label>
                    </div>
                    {/* {formData.vistoValidoEUA === 'sim' && (
                        <InputField type="file" name="fotoVistoEUA" label="Enviar foto do visto" onChange={handleInputChange} errors={errors} />
                    )} */}
                </div>
            </div>

            <div>
                <label>Você já viajou para outros países fora do Brasil nos últimos 5 anos?</label>
                <div>
                    <div>
                        <InputField type="radio" style={{ width: "auto" }} name="viagensInternacionais" value="nao" checked={formData.viagensInternacionais === 'nao'} onChange={handleInputChange} label="Não" errors={errors} />
                        <label>Não</label>
                    </div>
                    <div>
                        <InputField type="radio" style={{ width: "auto" }} name="viagensInternacionais" value="sim" checked={formData.viagensInternacionais === 'sim'} onChange={handleInputChange} label="Sim" errors={errors} />
                        <label>Sim</label>
                    </div>
                </div>
            </div>
            {(formData.viagensInternacionais === 'sim') && (
                <div>
                    <div className={styles.obsForm}>
                        <p>Adicione suas últimas viagens internacionais</p>
                    </div>

                    {(formData.listaViagens ?? []).map((viagem, index) => (
                        <div key={index}>
                            <InputField
                                name={`nomePais-${index}`}
                                value={viagem.nome}
                                onChange={(e) => handleInputChange(e, index, 'listaViagens', 'nome')}
                                label="Nome do país:"
                                errors={errors}
                                placeholder={`Nome do País ${index + 1}`}
                            />





                            <div>
                                <label>Datas de ida:</label>
                                <InputField
                                    name={`dataIda-${index}`}
                                    type="date"
                                    value={viagem.dataIda}
                                    onChange={(e) => handleInputChange(e, index, 'listaViagens', 'dataIda')}
                                    label="Data de ida:"
                                    errors={errors}
                                    placeholder={`Nome do acompanhante ${index + 1}`}
                                />
                            </div>

                            <div>
                                <label>Datas de volta:</label>

                                <InputField
                                    name={`dataVolta-${index}`}
                                    type="date"
                                    value={viagem.dataVolta}
                                    onChange={(e) => handleInputChange(e, index, 'listaViagens', 'dataVolta')}
                                    label="Data de volta:"
                                    errors={errors}
                                />
                            </div>


                            <InputField
                                name={`localPais-${index}`}
                                value={viagem.local}
                                onChange={(e) => handleInputChange(e, index, 'listaViagens', 'local')}
                                label="Local no país:"
                                errors={errors}
                                placeholder={`Local/cidade do País ${index + 1} aonde voce ficou`}

                            />
                            <InputField
                                name={`motivoPais-${index}`}
                                value={viagem.motivo}
                                onChange={(e) => handleInputChange(e, index, 'listaViagens', 'motivo')}
                                label="Motivo da viagem:"
                                errors={errors}
                                placeholder={`Motivo da viagem ao país ${index + 1}`}

                            />
                            <button type="button" onClick={() => removeEntry('listaViagens', index)}>- Remover</button>
                        </div>
                    ))}

                    {(formData.listaViagens?.length ?? 0) < 20 && (
                        <button type="button" onClick={() => addEntry('listaViagens')}>+ Adicionar Viagem</button>
                    )}
                </div>
            )}

        </div>
    );
}


// Etapa 4: Viagem e hospedagem
export function InformacoesViagemCanada({ formData, handleInputChange }) {
    return (
        <div>
            <h3>Viagem ao Canadá</h3>
            <label>Motivo da Viagem:</label>
            <textarea name="motivoViagem" value={formData.motivoViagem} onChange={handleInputChange} />

            <label>Datas pretendidas (entrada e saída):</label>
            <input name="datasPretendidas" value={formData.datasPretendidas} onChange={handleInputChange} />

            <label>Endereço de Hospedagem:</label>
            <input name="enderecoHospedagem" value={formData.enderecoHospedagem} onChange={handleInputChange} />
        </div>
    );
}

// Etapa 5: Uploads de documentos
export function DocumentosCanada({ formData, handleInputChange }) {
    return (
        <div>
            <h3>Documentos Obrigatórios (em construção)</h3>




            <label>Passaporte (digitalizado):</label>
            {/* <input type="file" onChange={e => handleInputChange('passaporte', e.target.files[0])} /> */}

            <label>Carta de Custeio (se houver):</label>
            {/* <input type="file" onChange={e => handleInputChange('cartaCusteio', e.target.files[0])} /> */}

            <label>Comprovante Financeiro (extrato, IR, contracheque):</label>
            {/* <input type="file" onChange={e => handleInputChange('comprovanteFinanceiro', e.target.files[0])} /> */}

            <label>Comprovante de Vínculo (declaração escolar, matrícula, carteira de trabalho):</label>
            {/* <input type="file" onChange={e => handleInputChange('comprovanteVinculo', e.target.files[0])} /> */}

            <label>Carta Convite (se for o caso):</label>
            {/* <input type="file" onChange={e => handleInputChange('cartaConvite', e.target.files[0])} /> */}




        </div>
    );
}



// Componente para a seção de Informações Adicionais
export function InformacoesAdicionaisCanada({ formData, handleInputChange, addEntry, removeEntry, setFormField, errors }) {
    return (
        <div>
            <h2>INFORMAÇÕES ADICIONAIS</h2>

            {/* Crime ou Condenação */}
            <div>
                <label>Você já cometeu, foi acusado, preso ou condenado por algum crime (incluindo dirigir sob efeito de álcool ou drogas)?</label>
                <div>
                    <InputField type="radio" style={{ width: "auto" }} name="teveCrime" value="nao" checked={formData.teveCrime === 'nao'} onChange={handleInputChange} errors={errors} />
                    <label>Não</label>
                </div>
                <div>
                    <InputField type="radio" style={{ width: "auto" }} name="teveCrime" value="sim" checked={formData.teveCrime === 'sim'} onChange={handleInputChange} errors={errors} />
                    <label>Sim</label>
                </div>
                {formData.teveCrime === 'sim' && (
                    <textarea name="explicacaoCrime" className={styles.textareaForm} value={formData.explicacaoCrime} onChange={handleInputChange} placeholder="Explique:" />
                )}
            </div>

            {/* Tuberculose */}
            <div>
                <label>Nos últimos 5 anos, você esteve em contato próximo com alguma pessoa com tuberculose?</label>
                <div>
                    <InputField type="radio" style={{ width: "auto" }} name="contatoTuberculose" value="nao" checked={formData.contatoTuberculose === 'nao'} onChange={handleInputChange} errors={errors} />
                    <label>Não</label>
                </div>
                <div>
                    <InputField type="radio" style={{ width: "auto" }} name="contatoTuberculose" value="sim" checked={formData.contatoTuberculose === 'sim'} onChange={handleInputChange} errors={errors} />
                    <label>Sim</label>
                </div>
                {formData.contatoTuberculose === 'sim' && (
                    <textarea name="explicacaoTuberculose" className={styles.textareaForm} value={formData.explicacaoTuberculose} onChange={handleInputChange} placeholder="Explique:" />
                )}
            </div>

            {/* Diálise */}
            <div>
                <label>Você está atualmente recebendo tratamento de diálise?</label>
                <div>
                    <InputField type="radio" style={{ width: "auto" }} name="dialise" value="nao" checked={formData.dialise === 'nao'} onChange={handleInputChange} errors={errors} />
                    <label>Não</label>
                </div>
                <div>
                    <InputField type="radio" style={{ width: "auto" }} name="dialise" value="sim" checked={formData.dialise === 'sim'} onChange={handleInputChange} errors={errors} />
                    <label>Sim</label>
                </div>
                {formData.dialise === 'sim' && (
                    <textarea name="explicacaoDialise" className={styles.textareaForm} value={formData.explicacaoDialise} onChange={handleInputChange} placeholder="Explique:" />
                )}
            </div>

            {/* Vício em Drogas ou Álcool */}
            <div>
                <label>Você já teve um vício em drogas ou álcool que o tornou uma ameaça para si mesmo ou para os outros, ou foi hospitalizado?</label>
                <div>
                    <InputField type="radio" style={{ width: "auto" }} name="vicioDrogas" value="nao" checked={formData.vicioDrogas === 'nao'} onChange={handleInputChange} errors={errors} />
                    <label>Não</label>
                </div>
                <div>
                    <InputField type="radio" style={{ width: "auto" }} name="vicioDrogas" value="sim" checked={formData.vicioDrogas === 'sim'} onChange={handleInputChange} errors={errors} />
                    <label>Sim</label>
                </div>
                {formData.vicioDrogas === 'sim' && (
                    <textarea name="explicacaoVicioDrogas" className={styles.textareaForm} value={formData.explicacaoVicioDrogas} onChange={handleInputChange} placeholder="Explique:" />
                )}
            </div>

            {/* Comunicação em Inglês ou Francês */}
            <div>
                <label>Você consegue se comunicar em Inglês ou Francês?</label>
                <div>
                    <InputField type="radio" style={{ width: "auto" }} name="falaInglesOuFrances" value="nao" checked={formData.falaInglesOuFrances === 'nao'} onChange={handleInputChange} errors={errors} />
                    <label>Não</label>
                </div>
                <div>
                    <InputField type="radio" style={{ width: "auto" }} name="falaInglesOuFrances" value="sim" checked={formData.falaInglesOuFrances === 'sim'} onChange={handleInputChange} errors={errors} />
                    <label>Sim</label>
                </div>
                {formData.falaInglesOuFrances === 'sim' && (
                    <InputField name="idiomaDominado" value={formData.idiomaDominado} onChange={handleInputChange} label="Qual idioma?" errors={errors} />
                )}
            </div>

            {/* Teste de Proficiência */}
            <div>
                <label>Você já fez algum teste de proficiência em Inglês ou Francês?</label>
                <div>
                    <InputField type="radio" style={{ width: "auto" }} name="fezTesteProficiencia" value="nao" checked={formData.fezTesteProficiencia === 'nao'} onChange={handleInputChange} errors={errors} />
                    <label>Não</label>
                </div>
                <div>
                    <InputField type="radio" style={{ width: "auto" }} name="fezTesteProficiencia" value="sim" checked={formData.fezTesteProficiencia === 'sim'} onChange={handleInputChange} errors={errors} />
                    <label>Sim</label>
                </div>
                {formData.fezTesteProficiencia === 'sim' && (
                    <InputField name="qualTesteProficiencia" value={formData.qualTesteProficiencia} onChange={handleInputChange} label="Qual teste?" errors={errors} />
                )}
            </div>

            {/* Idioma adicional */}
            <div>
                <label>Você fala algum outro idioma além do português?</label>
                <div>
                    <InputField type="radio" style={{ width: "auto" }} name="falaOutroIdioma" value="nao" checked={formData.falaOutroIdioma === 'nao'} onChange={handleInputChange} errors={errors} />
                    <label>Não</label>
                </div>
                <div>
                    <InputField type="radio" style={{ width: "auto" }} name="falaOutroIdioma" value="sim" checked={formData.falaOutroIdioma === 'sim'} onChange={handleInputChange} errors={errors} />
                    <label>Sim</label>
                </div>
                {formData.falaOutroIdioma === 'sim' && (
                    <InputField name="quaisIdiomas" value={formData.quaisIdiomas} onChange={handleInputChange} label="Quais?" errors={errors} />
                )}
            </div>

            {/* Serviço Militar */}
            <div>
                <label>Você prestou serviço militar?</label>
                <div>
                    <InputField
                        errors={errors}
                        style={{ width: "auto" }}
                        type="radio"
                        name="prestouMilitar"
                        value="nao"
                        checked={formData.prestouMilitar === 'nao'}
                        onChange={handleInputChange}
                    />
                    <label>Não</label>
                </div>
                <div>
                    <InputField
                        errors={errors}
                        style={{ width: "auto" }}
                        type="radio"
                        name="prestouMilitar"
                        value="sim"
                        checked={formData.prestouMilitar === 'sim'}
                        onChange={handleInputChange}
                    />
                    <label>Sim</label>
                </div>
                {formData.prestouMilitar === 'sim' && (
                    <div>
                        <h3>Detalhes do Serviço Militar:</h3>
                        <label>País onde prestou o serviço militar:</label>
                        <InputField
                            errors={errors}
                            type="text"
                            name="servicoMilitarPais"
                            value={formData.servicoMilitarPais}
                            onChange={handleInputChange}
                        />
                        <label>Nome do batalhão/tipo de serviço:</label>
                        <InputField
                            errors={errors}
                            type="text"
                            name="servicoMilitarBatalhao"
                            value={formData.servicoMilitarBatalhao}
                            onChange={handleInputChange}
                        />
                        <label>Posição/patente:</label>
                        <InputField
                            errors={errors}
                            type="text"
                            name="servicoMilitarPosicao"
                            value={formData.servicoMilitarPosicao}
                            onChange={handleInputChange}
                        />
                        <label>Especialidade militar:</label>
                        <InputField
                            errors={errors}
                            type="text"
                            name="servicoMilitarEspecialidade"
                            value={formData.servicoMilitarEspecialidade}
                            onChange={handleInputChange}
                        />
                        <label>Data de início do serviço:</label>
                        <InputField
                            errors={errors}
                            type="date"
                            name="servicoMilitarDataInicio"
                            value={formData.servicoMilitarDataInicio}
                            onChange={handleInputChange}
                        />
                        <label>Data do término do serviço:</label>
                        <InputField
                            errors={errors}
                            type="date"
                            name="servicoMilitarDataTermino"
                            value={formData.servicoMilitarDataTermino}
                            onChange={handleInputChange}
                        />
                    </div>
                )}
            </div>
        </div>
    );
}



// Função que renderiza a etapa de Informações de Viagem (visto canadense)
export function InformacoesDeViagemCanada({ formData, handleInputChange, errors, addEntry, removeEntry }) {


    return (
        <div>
            <h2>Informações de Viagem</h2>

            <div>
                <label>O que você gostaria de fazer no Canadá?</label>
                <InputField
                    errors={errors}

                    name="motivoViagemCanada"
                    value={formData.motivoViagemCanada}
                    onChange={handleInputChange}
                    multiline={true}
                    style={{ minHeight: "100px" }} // você pode customizar a altura mínima
                />
            </div>

            <div>
                <label>Data pretendida de CHEGADA no canada:</label>
                <InputField
                    errors={errors}
                    type="date"
                    name="dataPretendidaViagem"
                    value={formData.dataPretendidaViagem}
                    onChange={handleInputChange}
                />
            </div>
            <div>
                <label>Data pretendida de SAIDA do canada:</label>
                <InputField
                    errors={errors}
                    type="date"
                    name="dataPretendidaRetorno"
                    value={formData.dataPretendidaRetorno}
                    onChange={handleInputChange}
                />
            </div>

            <div>
                <label>Cidade pretendida:</label>
                <InputField
                    errors={errors}
                    type="text"
                    name="cidadePretendidaCanada"
                    value={formData.cidadePretendidaCanada}
                    onChange={handleInputChange}
                />
            </div>

            <div>
                <label>Locais que pretende conhecer:</label>
                <InputField
                    errors={errors}
                    type="text"
                    name="locaisVisitarCanada"
                    value={formData.locaisVisitarCanada}
                    onChange={handleInputChange}
                />
            </div>

            <div>
                <label>Qual valor você vai levar para sua viagem?</label>
                <InputField
                    errors={errors}
                    type="text"
                    name="valorViagemCanada"
                    value={formData.valorViagemCanada}
                    onChange={handleInputChange}
                />
            </div>

            <div>
                <label>Já possui passagem comprada?</label>
                <div>
                    <InputField
                        errors={errors}
                        style={{ width: "auto" }}
                        type="radio"
                        name="passagemCompradaCanada"
                        value="nao"
                        checked={formData.passagemCompradaCanada === 'nao'}
                        onChange={handleInputChange}
                    />
                    <label>Não</label>
                </div>
                <div>
                    <InputField
                        errors={errors}
                        style={{ width: "auto" }}
                        type="radio"
                        name="passagemCompradaCanada"
                        value="sim"
                        checked={formData.passagemCompradaCanada === 'sim'}
                        onChange={handleInputChange}
                    />
                    <label>Sim</label>
                </div>
            </div>

            <div>
                <label>Quem vai pagar a sua viagem?</label>
                <div>
                    <InputField
                        errors={errors}
                        style={{ width: "auto" }}
                        type="radio"
                        name="quemPagaViagem"
                        value="eu"
                        checked={formData.quemPagaViagem === 'eu'}
                        onChange={handleInputChange}
                    />
                    <label>Eu mesmo</label>
                </div>
                <div>
                    <InputField
                        errors={errors}
                        style={{ width: "auto" }}
                        type="radio"
                        name="quemPagaViagem"
                        value="outro"
                        checked={formData.quemPagaViagem === 'outro'}
                        onChange={handleInputChange}
                    />
                    <label>Outra pessoa</label>
                </div>
            </div>

            {formData.quemPagaViagem === 'outro' && (
                <div>
                    <label>Nome (sponsor):</label>
                    <InputField
                        errors={errors}
                        type="text"
                        name="sponsorNome"
                        value={formData.sponsorNome}
                        onChange={handleInputChange}
                    />
                    <label>Sobrenome (sponsor):</label>
                    <InputField
                        errors={errors}
                        type="text"
                        name="sponsorSobreNome"
                        value={formData.sponsorSobreNome}
                        onChange={handleInputChange}
                    />

                    <label>Telefone (sponsor):</label>
                    <InputField
                        errors={errors}
                        type="text"
                        name="sponsorTelefone"
                        value={formData.sponsorTelefone}
                        onChange={handleInputChange}
                    />

                    <label>Email (sponsor):</label>
                    <InputField
                        errors={errors}
                        type="email"
                        name="sponsorEmail"
                        value={formData.sponsorEmail}
                        onChange={handleInputChange}
                    />

                    <label>Grau de parentesco com o solicitante:</label>
                    <InputField
                        errors={errors}
                        type="text"
                        name="sponsorParentesco"
                        value={formData.sponsorParentesco}
                        onChange={handleInputChange}
                    />

                    <label>Endereço com CEP (sponsor):</label>
                    <InputField
                        errors={errors}
                        type="text"
                        name="sponsorEndereco"
                        value={formData.sponsorEndereco}
                        onChange={handleInputChange}
                    />
                </div>
            )}




            <div>
                <div className={styles.obsForm}>
                    <p>São Pessoas que vão viajar junto com você para o Canada. (Informe nome COMPLETO e Grau de Parentesco)</p>

                </div>
                {formData.acompanhantes.map((acompanhante, index) => (
                    <div key={index}>
                        {acompanhante.nome && (
                            <span style={{ fontSize: "0.9em", color: "#555", paddingLeft: "10px" }}>
                                {acompanhante.nome.length} / 33
                            </span>
                        )}
                        <div>
                            <InputField
                                errors={errors}
                                type="text"
                                name={`acompanhanteNome-${index}`}
                                value={acompanhante.nome}
                                onChange={(e) => handleInputChange(e, index, 'acompanhantes', 'nome')}
                                placeholder={`Nome do acompanhante ${index + 1}`}
                                maxLength={33}

                            />
                        </div>

                        {acompanhante.sobrenome && (
                            <span style={{ fontSize: "0.9em", color: "#555", paddingLeft: "10px" }}>
                                {acompanhante.sobrenome.length} / 33
                            </span>
                        )}

                        <div>
                            <InputField
                                errors={errors}
                                type="text"
                                name={`acompanhanteSobreNome-${index}`}
                                value={acompanhante.sobrenome}
                                onChange={(e) => handleInputChange(e, index, 'acompanhantes', 'sobrenome')}
                                placeholder={`sobrenome do acompanhante ${index + 1}`}
                                maxLength={33}
                            />
                        </div>


                        <select
                            name={`acompanhanteParentesco-${index}`}
                            value={acompanhante.parentesco}
                            onChange={(e) => handleInputChange(e, index, 'acompanhantes', 'parentesco')}
                        >
                            <option value="">Parentesco</option>
                            <option value="P">PAIS</option>
                            <option value="S">MARIDO/ESPOSA</option>
                            <option value="C">FILHOS</option>
                            <option value="R">OUTRO FAMILIAR</option>
                            <option value="F">AMIGO</option>
                            <option value="B">BUSINESS ASSOCIATE</option>
                            <option value="O">OUTROS</option>
                        </select>

                        <div >
                            <button type="button"
                                style={{ color: " red", backgroundColor: '#ffffff00', marginBottom: "20px", padding: "5px", border: "solid 1px  red", borderRadius: "20px" }}
                                onClick={() => removeEntry('acompanhantes', index)}>- Remover</button>
                        </div>


                    </div>
                ))}
                {formData.acompanhantes.length < 10 && (
                    <button type="button" onClick={() => addEntry('acompanhantes')}>+ Adicionar Acompanhante</button>
                )}
            </div>






        </div>
    );
}



// Função que renderiza a etapa de Ocupação Atual
export function OcupacaoAtualCanada({ formData, handleInputChange, errors, addEntry, removeEntry }) {
    return (
        <div>
            <h2>Ocupação Atual</h2>
            <select
                type="text"
                name="ocupacaoAtualSelect"
                value={formData.ocupacaoAtualSelect}
                onChange={handleInputChange}
            >
                <option value="">Selecione uma Categoria</option>
                <option value="A">Agricultura</option>
                <option value="AP">Artista/Intérprete</option>
                <option value="B">Negócios</option>
                <option value="CM">Comunicações</option>
                <option value="CS">Ciência da Computação</option>
                <option value="C">Culinária/Serviços de Alimentação</option>
                <option value="ED">Educação</option>
                <option value="EN">Engenharia</option>
                <option value="G">Governo</option>
                <option value="H">Dona de Casa</option>
                <option value="LP">Profissão Jurídica</option>
                <option value="MH">Médico/Serviços de Saúde</option>
                <option value="M">Militar</option>
                <option value="NS">Ciências Naturais</option>
                <option value="N">Não Empregado</option>
                <option value="PS">Ciências Físicas</option>
                <option value="RV">Vocação Religiosa</option>
                <option value="R">Pesquisa</option>
                <option value="RT">Aposentado</option>
                <option value="SS">Ciências Sociais</option>
                <option value="S">Estudante</option>
                <option value="O">Outro</option>
            </select>



            <div>
                <label>Ocupação Atual (Cargo):</label>
                <InputField
                    errors={errors}
                    type="text"
                    name="ocupacaoAtual"
                    value={formData.ocupacaoAtual}
                    onChange={handleInputChange}
                />
            </div>
            <div>
                <label>Se desempregado, explique:</label>
                <textarea
                    className={styles.textareaForm}
                    name="explicacaoDesempregado"
                    value={formData.explicacaoDesempregado}
                    onChange={handleInputChange}
                />
            </div>
            <div>
                <label>Nome da Empresa:</label>
                {formData.empresa && (
                    <span style={{ fontSize: "0.9em", color: "#555", paddingLeft: "10px" }}>
                        {formData.empresa.length} / 75
                    </span>
                )}
                <InputField
                    errors={errors}
                    type="text"
                    name="empresa"
                    value={formData.empresa}
                    onChange={handleInputChange}
                    maxLength={75}
                />
            </div>
            <div>
                <label>Data de Início:</label>
                <InputField
                    errors={errors}
                    type="date"
                    name="dataInicio"
                    value={formData.dataInicio}
                    onChange={handleInputChange}
                />
            </div>
            <div>
                <label>Endereço:
                    {formData.enderecoEmpresa && (
                        <span style={{ fontSize: "0.9em", color: "#555", paddingLeft: "10px" }}>
                            {formData.enderecoEmpresa.length} / 40
                        </span>
                    )}

                </label>
                <InputField
                    errors={errors}
                    type="text"
                    name="enderecoEmpresa"
                    value={formData.enderecoEmpresa}
                    onChange={handleInputChange}
                    maxLength={40}
                />
            </div>
            <div>
                <label>Bairro:
                    {formData.bairroEmpresa && (
                        <span style={{ fontSize: "0.9em", color: "#555", paddingLeft: "10px" }}>
                            {formData.bairroEmpresa.length} / 40
                        </span>
                    )}
                </label>
                <InputField
                    errors={errors}
                    type="text"
                    name="bairroEmpresa"
                    value={formData.bairroEmpresa}
                    onChange={handleInputChange}
                    maxLength={40}
                />
            </div>
            <div>
                <label>Cidade:
                    {formData.cidadeEmpresa && (
                        <span style={{ fontSize: "0.9em", color: "#555", paddingLeft: "10px" }}>
                            {formData.cidadeEmpresa.length} / 20
                        </span>
                    )}
                </label>
                <InputField
                    errors={errors}
                    type="text"
                    name="cidadeEmpresa"
                    value={formData.cidadeEmpresa}
                    onChange={handleInputChange}
                    maxLength={20}
                />
            </div>
            <div>
                <div>
                    <label>Estado:</label>
                </div>
                <select name="estadoEmpresa" value={formData.estadoEmpresa} onChange={handleInputChange}>
                    <option value="">- Selecione um estado -</option>
                    {estadosBrasileiros.map((estado) => (
                        <option key={estado.value} value={estado.value}>
                            {estado.label}
                        </option>
                    ))}
                </select>
            </div>
            <div>
                <div>
                    <label>CEP:</label>

                </div>
                <InputField
                    errors={errors}
                    type="number"
                    name="cepEmpresa"
                    value={formData.cepEmpresa}
                    onChange={handleInputChange}
                />
            </div>
            <div>
                <label>Telefone:</label>
                {formData.telefoneEmpresa && (
                    <span style={{ fontSize: "0.9em", color: "#555", paddingLeft: "10px" }}>
                        {formData.telefoneEmpresa.length} / 15
                    </span>
                )}
                <InputField
                    errors={errors}
                    type="text"
                    name="telefoneEmpresa"
                    value={formData.telefoneEmpresa}
                    onChange={(e) => sanitizeNumberInput(e, handleInputChange)}

                    maxLength={15}
                    inputMode="numeric"
                    pattern="[0-9]*"
                    placeholder="Digite apenas números"
                />

            </div>
            <div>
                <label>
                    Média da Renda Mensal Líquida:
                    <span style={{ display: "block", fontSize: "0.9em", color: "#888", marginTop: "2px" }}>
                        Digite apenas o valor inteiro, sem centavos.
                    </span>
                </label>
                <div style={{ position: 'relative', display: 'inline-block' }}>
                    <InputField
                        errors={errors}
                        // type="text"
                        name="rendaMensal"
                        value={formData.rendaMensal}
                        onChange={(e) => sanitizeNumberInput(e, handleInputChange)}
                        placeholder="Ex: 2500"


                        inputMode="numeric"
                        pattern="[0-9]*"
                    />
                    <span
                        style={{
                            position: 'absolute',
                            right: '-10px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            color: '#777',
                            pointerEvents: 'none',
                            fontSize: '1.0rem'

                        }}
                    >
                        ,00
                    </span>
                </div>
            </div>
            {/* <div>
                <label>Função:</label>
                <InputField
                    errors={errors}
                    type="text"
                    name="funcao"
                    value={formData.funcao}
                    onChange={handleInputChange}
                />
            </div> */}
            <div>
                <label>Breve Explicação da Função:</label>
                {formData.explicacaoFuncao && (
                    <span style={{ fontSize: "0.9em", color: "#555", paddingLeft: "10px" }}>
                        {formData.explicacaoFuncao.length} / 4000
                    </span>
                )}
                <textarea
                    className={styles.textareaForm}
                    name="explicacaoFuncao"
                    value={formData.explicacaoFuncao}
                    onChange={handleInputChange}
                    maxLength={4000}
                />
            </div>
            <div>
                <label>Trabalho autônomo ou possui Empresa?</label>
                <div>
                    <InputField
                        errors={errors}
                        style={{ width: "auto" }}
                        type="radio"
                        name="trabalhoAutonomoOuEmpresa"
                        value="nao"
                        checked={formData.trabalhoAutonomoOuEmpresa === 'nao'}
                        onChange={handleInputChange}
                    />
                    <label>Não</label>
                </div>
                <div>
                    <InputField
                        errors={errors}
                        style={{ width: "auto" }}
                        type="radio"
                        name="trabalhoAutonomoOuEmpresa"
                        value="sim"
                        checked={formData.trabalhoAutonomoOuEmpresa === 'sim'}
                        onChange={handleInputChange}
                    />
                    <label>Sim</label>
                </div>
                {formData.trabalhoAutonomoOuEmpresa === 'sim' && (
                    <div>
                        <label>Informe MEI ou CNPJ:</label>
                        <InputField
                            errors={errors}
                            type="text"
                            name="meiCnpj"
                            value={formData.meiCnpj}
                            onChange={handleInputChange}
                        />
                    </div>
                )}
            </div>
        </div>
    );
}


// Componente para a seção de Formações Acadêmicas
export function OcupacaoAnteriorCanada({ formData, handleInputChange, errors, addEntry, removeEntry }) {
    return (
        <div>
            <div>
                <h2>Ocupações Anteriores</h2>
                <div className={styles.obsForm}>
                    <p>Informe seus últimos trabalhos de até 5 anos atrás.</p>

                </div>
                {formData.ocupacaoAnterior.map((ocupacao, index) => (
                    <div key={index}>
                        <h3>Ocupação {index + 1}</h3>
                        <label>Nome da Empresa:</label>
                        {ocupacao.empresa && (
                            <span style={{ fontSize: "0.9em", color: "#555", paddingLeft: "10px" }}>
                                {ocupacao.empresa.length} / 75
                            </span>
                        )}
                        <InputField
                            errors={errors}
                            type="text"
                            name={`empresa-${index}`}
                            value={ocupacao.empresa}
                            onChange={(e) => handleInputChange(e, index, 'ocupacaoAnterior', 'empresa')}
                            maxLength={75}
                        />
                        <label>Endereço:</label>
                        {ocupacao.endereco && (
                            <span style={{ fontSize: "0.9em", color: "#555", paddingLeft: "10px" }}>
                                {ocupacao.endereco.length} / 40
                            </span>
                        )}
                        <InputField
                            errors={errors}
                            type="text"
                            name={`endereco-${index}`}
                            value={ocupacao.endereco}
                            onChange={(e) => handleInputChange(e, index, 'ocupacaoAnterior', 'endereco')}
                            maxLength={40}
                        />
                        <label>Bairro:</label>
                        {ocupacao.bairro && (
                            <span style={{ fontSize: "0.9em", color: "#555", paddingLeft: "10px" }}>
                                {ocupacao.bairro.length} / 40
                            </span>
                        )}
                        <InputField
                            errors={errors}
                            type="text"
                            name={`bairro-${index}`}
                            value={ocupacao.bairro}
                            onChange={(e) => handleInputChange(e, index, 'ocupacaoAnterior', 'bairro')}
                            maxLength={40}
                        />
                        <label>Cidade:</label>
                        {ocupacao.cidade && (
                            <span style={{ fontSize: "0.9em", color: "#555", paddingLeft: "10px" }}>
                                {ocupacao.cidade.length} / 20
                            </span>
                        )}
                        <InputField
                            errors={errors}
                            type="text"
                            name={`cidade-${index}`}
                            value={ocupacao.cidade}
                            onChange={(e) => handleInputChange(e, index, 'ocupacaoAnterior', 'cidade')}
                            maxLength={20}
                        />
                        <div>
                            <div>
                                <label>Estado:</label>
                            </div>
                            <select name={`estado-${index}`} value={ocupacao.estado} onChange={(e) => handleInputChange(e, index, 'ocupacaoAnterior', 'estado')} >
                                <option value="">- Selecione um estado -</option>
                                {estadosBrasileiros.map((estado) => (
                                    <option key={estado.value} value={estado.value}>
                                        {estado.label}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div>
                            <label>CEP:</label>

                        </div>
                        <InputField
                            errors={errors}
                            type="text"
                            name={`cep-${index}`}
                            value={ocupacao.cep}
                            onChange={(e) => handleInputChange(e, index, 'ocupacaoAnterior', 'cep')}
                        />
                        <label>Telefone:</label>
                        {ocupacao.telefone && (
                            <span style={{ fontSize: "0.9em", color: "#555", paddingLeft: "10px" }}>
                                {ocupacao.telefone.length} / 15
                            </span>
                        )}
                        <InputField
                            errors={errors}
                            type="text"
                            name={`telefone-${index}`}
                            value={ocupacao.telefone}
                            onChange={(e) => {
                                const onlyNumbers = e.target.value.replace(/\D/g, '');
                                handleInputChange(
                                    {
                                        target: {
                                            name: e.target.name,
                                            value: onlyNumbers,
                                        },
                                    },
                                    index,
                                    'ocupacaoAnterior',
                                    'telefone'
                                );
                            }}
                            maxLength={15}
                            inputMode="numeric"
                            pattern="[0-9]*"
                            placeholder="Digite apenas números"
                        />

                        <label>Cargo:</label>
                        <InputField
                            errors={errors}
                            type="text"
                            name={`cargo-${index}`}
                            value={ocupacao.cargo}
                            onChange={(e) => handleInputChange(e, index, 'ocupacaoAnterior', 'cargo')}
                        />
                        <label>Data de Admissão:</label>
                        <InputField
                            errors={errors}
                            type="date"
                            name={`dataAdmissao-${index}`}
                            value={ocupacao.dataAdmissao}
                            onChange={(e) => handleInputChange(e, index, 'ocupacaoAnterior', 'dataAdmissao')}
                        />
                        <label>Data de Demissão:</label>
                        <InputField
                            errors={errors}
                            type="date"
                            name={`dataDemissao-${index}`}
                            value={ocupacao.dataDemissao}
                            onChange={(e) => handleInputChange(e, index, 'ocupacaoAnterior', 'dataDemissao')}
                            disabled={ocupacao.aindaEmpregado}
                            style={{
                                backgroundColor: ocupacao.aindaEmpregado ? '#A9A9A9' : 'white',
                            }}
                        />
                        <div>
                            <InputField
                                errors={errors}
                                type="checkbox"
                                style={{ width: "auto", marginRight: "5px" }}
                                name={`aindaEmpregado-${index}`}
                                checked={ocupacao.aindaEmpregado}
                                onChange={(e) => handleInputChange(e, index, 'ocupacaoAnterior', 'aindaEmpregado')}
                            />
                            Ainda Empregado
                        </div>
                        <label>Descrição das Funções:</label>
                        {ocupacao.descricao && (
                            <span style={{ fontSize: "0.9em", color: "#555", paddingLeft: "10px" }}>
                                {ocupacao.descricao.length} / 4000
                            </span>
                        )}
                        <textarea
                            className={styles.textareaForm}
                            name={`descricao-${index}`}
                            value={ocupacao.descricao}
                            onChange={(e) => handleInputChange(e, index, 'ocupacaoAnterior', 'descricao')}
                            maxLength={4000}
                        />
                        <button type="button"
                            style={{ color: " red", backgroundColor: '#ffffff00', marginBottom: "20px", padding: "5px", border: "solid 1px  red", borderRadius: "20px" }}
                            onClick={() => removeEntry('ocupacaoAnterior', index)}>- Remover Ocupação</button>
                    </div>
                ))}
                {formData.ocupacaoAnterior.length < 10 && (
                    <div>
                        <button type="button" onClick={() => addEntry('ocupacaoAnterior')}>
                            + Adicionar Ocupação
                        </button>
                        <div>
                            {/* <p>Até 2 ocupações anteriores.</p> */}
                        </div>
                    </div>
                )}
            </div>
            <h2>Formações Acadêmicas</h2>
            <div className={styles.obsForm}>
                <div>
                    <label >(Ensino Superior, Curso técnico/profissionalizante, Ensino Médio)</label>
                </div>
                <div>
                    <label>mesmo que não tenha concluído.</label>
                </div>
            </div>

            {formData.formacaoAcademica.map((formacao, index) => (
                <div key={index}>
                    <h3>Formação {index + 1}</h3>
                    <label>Nome da Instituição:</label>
                    {formacao.instituicao && (
                        <span style={{ fontSize: "0.9em", color: "#555", paddingLeft: "10px" }}>
                            {formacao.instituicao.length} / 75
                        </span>
                    )}
                    <InputField
                        errors={errors}
                        type="text"
                        name={`instituicao-${index}`}
                        value={formacao.instituicao}
                        onChange={(e) => handleInputChange(e, index, 'formacaoAcademica', 'instituicao')}
                        maxLength={75}
                    />
                    <label>Endereço:</label>
                    {formacao.endereco && (
                        <span style={{ fontSize: "0.9em", color: "#555", paddingLeft: "10px" }}>
                            {formacao.endereco.length} / 40
                        </span>
                    )}
                    <InputField
                        errors={errors}
                        type="text"
                        name={`endereco-${index}`}
                        value={formacao.endereco}
                        onChange={(e) => handleInputChange(e, index, 'formacaoAcademica', 'endereco')}
                        maxLength={40}
                    />
                    <label>Bairro:</label>
                    {formacao.bairro && (
                        <span style={{ fontSize: "0.9em", color: "#555", paddingLeft: "10px" }}>
                            {formacao.bairro.length} / 40
                        </span>
                    )}
                    <InputField
                        errors={errors}
                        type="text"
                        name={`bairro-${index}`}
                        value={formacao.bairro}
                        onChange={(e) => handleInputChange(e, index, 'formacaoAcademica', 'bairro')}
                        maxLength={40}
                    />
                    <label>Cidade:</label>
                    {formacao.cidade && (
                        <span style={{ fontSize: "0.9em", color: "#555", paddingLeft: "10px" }}>
                            {formacao.cidade.length} / 20
                        </span>
                    )}
                    <InputField
                        errors={errors}
                        type="text"
                        name={`cidade-${index}`}
                        value={formacao.cidade}
                        onChange={(e) => handleInputChange(e, index, 'formacaoAcademica', 'cidade')}
                        maxLength={20}
                    />
                    <div>
                        <div>
                            <label>Estado:</label>

                        </div>
                        <select name={`estado-${index}`} value={formacao.estado} onChange={(e) => handleInputChange(e, index, 'formacaoAcademica', 'estado')}>
                            <option value="">- Selecione um estado -</option>
                            {estadosBrasileiros.map((estado) => (
                                <option key={estado.value} value={estado.value}>
                                    {estado.label}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div>
                        <label>CEP:</label>

                    </div>
                    <InputField
                        errors={errors}
                        type="text"
                        name={`cep-${index}`}
                        value={formacao.cep}
                        onChange={(e) => handleInputChange(e, index, 'formacaoAcademica', 'cep')}
                    />
                    <label>Curso de Estudo:</label>
                    {formacao.curso && (
                        <span style={{ fontSize: "0.9em", color: "#555", paddingLeft: "10px" }}>
                            {formacao.curso.length} / 66
                        </span>
                    )}
                    <InputField
                        errors={errors}
                        type="text"
                        name={`curso-${index}`}
                        value={formacao.curso}
                        onChange={(e) => handleInputChange(e, index, 'formacaoAcademica', 'curso')}
                        maxLength={66}
                    />
                    <label>Data de Início:</label>
                    <InputField
                        errors={errors}
                        type="date"
                        name={`dataInicio-${index}`}
                        value={formacao.dataInicio}
                        onChange={(e) => handleInputChange(e, index, 'formacaoAcademica', 'dataInicio')}
                    />
                    <label>Data de Término:</label>
                    <InputField
                        errors={errors}
                        type="date"
                        name={`dataTermino-${index}`}
                        value={formacao.dataTermino}
                        onChange={(e) => handleInputChange(e, index, 'formacaoAcademica', 'dataTermino')}
                        disabled={formacao.aindaEstudando}
                        style={{
                            backgroundColor: formacao.aindaEstudando ? '#A9A9A9' : 'white',
                        }}
                    />
                    <div>
                        <InputField
                            errors={errors}
                            type="checkbox"
                            style={{ width: "auto", marginRight: "5px" }}
                            name={`aindaEstudando-${index}`}
                            checked={formacao.aindaEstudando}
                            onChange={(e) => handleInputChange(e, index, 'formacaoAcademica', 'aindaEstudando')}
                        />
                        Ainda Estudando
                    </div>
                    <button type="button"
                        style={{ color: " red", backgroundColor: '#ffffff00', marginBottom: "20px", padding: "5px", border: "solid 1px  red", borderRadius: "20px" }}
                        onClick={() => removeEntry('formacaoAcademica', index)}>- Remover Formação</button>
                </div>
            ))}
            {formData.formacaoAcademica.length < 5 && (
                <button type="button" onClick={() => addEntry('formacaoAcademica')}>
                    + Adicionar Formação
                </button>
            )}
        </div>
    );
}



// Função que renderiza a etapa de Informações de Família e Contatos nos EUA
export function InformacoesFamiliaCanada({ formData, handleInputChange, errors, addEntry, removeEntry, }) {

    formData.filhos = formData.filhos || [];

    return (
        <div>
            <h2>Informações de Família</h2>


            <div className={styles.groupDiv}>
                <h2>Pai</h2>

                <div>
                    {/* <h2>Pai:</h2> */}
                    <label>Nome :</label>
                    <InputField
                        errors={errors}
                        type="text"
                        name="nomePai"
                        value={formData.nomePai}
                        onChange={handleInputChange}
                        disabled={formData.desconheceNomePai === 'sim'}
                        style={{
                            backgroundColor: formData.desconheceNomePai === 'sim' ? '#a9a9a9' : 'white'
                        }}
                    />
                    <label>Sobrenome:</label>
                    <InputField
                        errors={errors}
                        type="text"
                        name="sobrenomePai"
                        value={formData.sobrenomePai}
                        onChange={handleInputChange}
                        disabled={formData.desconheceNomePai === 'sim'}
                        style={{
                            backgroundColor: formData.desconheceNomePai === 'sim' ? '#a9a9a9' : 'white'
                        }}
                    />
                    <div>
                        <InputField
                            errors={errors}
                            type="checkbox"
                            style={{ width: "auto", marginRight: "5px" }}
                            name="desconheceNomePai"
                            checked={formData.desconheceNomePai === 'sim'}
                            onChange={handleInputChange}
                        />
                        <label>Não sei</label>
                    </div>
                </div>
                <div>
                    <label>Data de Nascimento:</label>
                    <InputField
                        errors={errors}
                        type="date"
                        name="dataNascimentoPai"
                        value={formData.dataNascimentoPai}
                        onChange={handleInputChange}
                        disabled={formData.desconheceDataNascimentoPai === 'sim'}
                        style={{
                            backgroundColor: formData.desconheceDataNascimentoPai === 'sim' ? '#a9a9a9' : 'white'
                        }}
                    />
                    <div>
                        <InputField
                            errors={errors}
                            type="checkbox"
                            style={{ width: "auto", marginRight: "5px" }}
                            name="desconheceDataNascimentoPai"
                            checked={formData.desconheceDataNascimentoPai === 'sim'}
                            onChange={handleInputChange}
                        />
                        <label>Não sei</label>
                    </div>
                </div>

                <div>
                    <label>Endereço com CEP (se diferente do seu):
                    </label>
                    <InputField
                        errors={errors}
                        type="text"
                        name="enderecoPai"
                        value={formData.enderecoPai}
                        onChange={handleInputChange}
                    />
                </div>
                <div>
                    <label>Trabalho (se aplicável):
                    </label>
                    <InputField
                        errors={errors}
                        type="text"
                        name="trabalhoPai"
                        value={formData.trabalhoPai}
                        onChange={handleInputChange}
                    />
                </div>
            </div>




            <div className={styles.groupDiv}>
                <h2>Mãe</h2>
                <div>
                    <label>Nome:</label>
                    <InputField
                        errors={errors}
                        type="text"
                        name="nomeMae"
                        value={formData.nomeMae}
                        onChange={handleInputChange}
                        disabled={formData.desconheceNomeMae === 'sim'}
                        style={{
                            backgroundColor: formData.desconheceNomeMae === 'sim' ? '#a9a9a9' : 'white'
                        }}
                    />
                    <label>Sobrenome:</label>
                    <InputField
                        errors={errors}
                        type="text"
                        name="sobrenomeMae"
                        value={formData.sobrenomeMae}
                        onChange={handleInputChange}
                        disabled={formData.desconheceNomeMae === 'sim'}
                        style={{
                            backgroundColor: formData.desconheceNomeMae === 'sim' ? '#a9a9a9' : 'white'
                        }}
                    />
                    <div>
                        <InputField
                            errors={errors}
                            type="checkbox"
                            style={{ width: "auto", marginRight: "5px" }}
                            name="desconheceNomeMae"
                            checked={formData.desconheceNomeMae === 'sim'}
                            onChange={handleInputChange}
                        />
                        <label>Não sei</label>
                    </div>
                </div>
                <div>
                    <label>Data de Nascimento:</label>
                    <InputField
                        errors={errors}
                        type="date"
                        name="dataNascimentoMae"
                        value={formData.dataNascimentoMae}
                        onChange={handleInputChange}
                        disabled={formData.desconheceDataNascimentoMae === 'sim'}
                        style={{
                            backgroundColor: formData.desconheceDataNascimentoMae === 'sim' ? '#a9a9a9' : 'white'
                        }}
                    />
                </div>
                <div>
                    <InputField
                        errors={errors}
                        type="checkbox"
                        style={{ width: "auto", marginRight: "5px" }}
                        name="desconheceDataNascimentoMae"
                        checked={formData.desconheceDataNascimentoMae === 'sim'}
                        onChange={handleInputChange}
                    />
                    <label>Não sei</label>
                </div>
                <div>
                    <label>Endereço com CEP (se diferente do seu):
                    </label>
                    <InputField
                        errors={errors}
                        type="text"
                        name="enderecoMae"
                        value={formData.enderecoMae}
                        onChange={handleInputChange}
                    />
                </div>
                <div>
                    <label>Trabalho (se aplicável):
                    </label>
                    <InputField
                        errors={errors}
                        type="text"
                        name="trabalhoMae"
                        value={formData.trabalhoMae}
                        onChange={handleInputChange}
                    />
                </div>

            </div>

            <div>
                <label>Você tem filhos biológicos, adotivos ou enteados?</label>
                <div>
                    <InputField
                        errors={errors}
                        style={{ width: "auto" }}
                        type="radio"
                        name="temFilhos"
                        value="nao"
                        checked={formData.temFilhos === 'nao'}
                        onChange={handleInputChange}
                    />
                    <label>Não</label>
                </div>
                <div>
                    <InputField
                        errors={errors}
                        style={{ width: "auto" }}
                        type="radio"
                        name="temFilhos"
                        value="sim"
                        checked={formData.temFilhos === 'sim'}
                        onChange={handleInputChange}
                    />
                    <label>Sim</label>
                </div>
                {formData.temFilhos === 'sim' && (
                    <div>
                        {(formData.filhos || []).map((filho, index) => (
                            <div key={index}>
                                <div>
                                    <label>Nome:</label>
                                    <InputField
                                        errors={errors}
                                        type="text"
                                        name={`nomeFilho-${index}`}
                                        value={filho.nome}
                                        onChange={(e) => handleInputChange(e, index, 'filhos', 'nome')}
                                    />
                                </div>
                                <div>
                                    <label>Sobrenome:</label>
                                    <InputField
                                        errors={errors}
                                        type="text"
                                        name={`SobrenomeFilho-${index}`}
                                        value={filho.Sobrenome}
                                        onChange={(e) => handleInputChange(e, index, 'filhos', 'Sobrenome')}
                                    />
                                </div>
                                <div>
                                    <label>Sexo:</label>
                                    <select
                                        name={`sexoFilho-${index}`}
                                        value={filho.sexo}
                                        onChange={(e) => handleInputChange(e, index, 'filhos', 'sexo')}
                                    >
                                        <option value="">- SELECIONE -</option>
                                        <option value="M">Masculino</option>
                                        <option value="F">Feminino</option>
                                        <option value="O">Outro</option>
                                    </select>
                                </div>
                                <div>
                                    <label>Data de nascimento:</label>
                                    <InputField
                                        errors={errors}
                                        type="date"
                                        name={`dataNascimentoFilho-${index}`}
                                        value={filho.dataNascimento}
                                        onChange={(e) => handleInputChange(e, index, 'filhos', 'dataNascimento')}
                                    />
                                </div>
                                <div>
                                    <label>Relação:</label>
                                    <select
                                        name={`relacaoFilho-${index}`}
                                        value={filho.relacao}
                                        onChange={(e) => handleInputChange(e, index, 'filhos', 'relacao')}
                                    >
                                        <option value="">- SELECIONE -</option>
                                        <option value="filho">Filho(a) biológico(a)</option>
                                        <option value="adotivo">Adotivo(a)</option>
                                        <option value="enteado">Enteado(a)</option>
                                    </select>
                                </div>
                                <div>
                                    <label>Mora no mesmo endereço que você?</label>
                                    <div>
                                        <InputField
                                            errors={errors}
                                            style={{ width: "auto" }}
                                            type="radio"
                                            name={`moraMesmoEndereco-${index}`}
                                            value="sim"
                                            checked={filho.moraMesmoEndereco === 'sim'}
                                            onChange={(e) => handleInputChange(e, index, 'filhos', 'moraMesmoEndereco')}
                                        />
                                        <label>Sim</label>
                                    </div>
                                    <div>
                                        <InputField
                                            errors={errors}
                                            style={{ width: "auto" }}
                                            type="radio"
                                            name={`moraMesmoEndereco-${index}`}
                                            value="nao"
                                            checked={filho.moraMesmoEndereco === 'nao'}
                                            onChange={(e) => handleInputChange(e, index, 'filhos', 'moraMesmoEndereco')}
                                        />
                                        <label>Não</label>
                                    </div>
                                </div>
                                {filho.moraMesmoEndereco === 'nao' && (
                                    <>
                                        <label>Endereço onde reside:</label>
                                        <InputField
                                            errors={errors}
                                            type="text"
                                            name={`enderecoFilho-${index}`}
                                            value={filho.endereco}
                                            onChange={(e) => handleInputChange(e, index, 'filhos', 'endereco')}
                                        />
                                    </>
                                )}
                                <button
                                    style={{
                                        color: "red",
                                        backgroundColor: '#ffffff00',
                                        marginBottom: "20px",
                                        padding: "5px",
                                        border: "solid 1px red",
                                        borderRadius: "20px"
                                    }}
                                    type="button"
                                    onClick={() => removeEntry('filhos', index)}
                                >
                                    - Remover Filho
                                </button>
                            </div>
                        ))}
                        {formData.filhos.length < 10 && (
                            <button type="button" onClick={() => addEntry('filhos')}>+ Adicionar Filho</button>
                        )}
                    </div>
                )}
            </div>
















            <h2>Contatos com o CANADA</h2>


            <div>
                <label>Você possui algum parente, amigo ou contato no CANADA? (Pai, Mãe, Irmãos, Filhos, amigos, contatos proximos)</label>
                <div>
                    <InputField
                        errors={errors}
                        style={{ width: "auto" }}
                        type="radio"
                        name="parenteImediatoCanada"
                        value="nao"
                        checked={formData.parenteImediatoCanada === 'nao'}
                        onChange={handleInputChange}
                    />
                    <label>Não</label>
                </div>
                <div>
                    <InputField
                        errors={errors}
                        style={{ width: "auto" }}
                        type="radio"
                        name="parenteImediatoCanada"
                        value="sim"
                        checked={formData.parenteImediatoCanada === 'sim'}
                        onChange={handleInputChange}
                    />
                    <label>Sim</label>
                </div>
                {formData.parenteImediatoCanada === 'sim' && (
                    <div>
                        {formData.parentesImediatos.map((parente, index) => (
                            <div key={index}>
                                <label>Nome:</label>
                                <InputField
                                    errors={errors}
                                    type="text"
                                    name={`nomeParenteCanada-${index}`}
                                    value={parente.nome}
                                    onChange={(e) => handleInputChange(e, index, 'parentesImediatos', 'nome')}
                                />
                                <label>Sobrenome:</label>
                                <InputField
                                    errors={errors}
                                    type="text"
                                    name={`sobreNomeParenteCanada-${index}`}
                                    value={parente.sobrenome}
                                    onChange={(e) => handleInputChange(e, index, 'parentesImediatos', 'sobrenome')}
                                />
                                <div>
                                    <label>Grau de Parentesco:</label>

                                    <select
                                        type="select"
                                        name={`grauParentescoParenteCanada-${index}`}
                                        value={parente.grauParentesco}
                                        onChange={(e) => handleInputChange(e, index, 'parentesImediatos', 'grauParentesco')}
                                    >
                                        <option selected="selected" value="">- SELECIONE UM -</option>
                                        <option value="S">CÔNJUGE</option>
                                        <option value="F">NOIVO/NOIVA</option>
                                        <option value="C">FILHO</option>
                                        <option value="B">IRMÃO</option>

                                    </select>
                                </div>
                                <div>
                                    <label>Situação (cidadão canadense, residente permanente legal, imigrante...):</label>
                                    <select
                                        type="select"
                                        name={`situacaoParenteCanada-${index}`}
                                        value={parente.situacao}
                                        onChange={(e) => handleInputChange(e, index, 'parentesImediatos', 'situacao')}
                                    >
                                        <option selected="selected" value="">- SELECIONE UMA OPÇÃO -</option>
                                        <option value="S">CIDADÃO CANADENSE</option>
                                        <option value="C">RESIDENTE PERMANENTE LEGAL (LPR)</option>
                                        <option value="P">NÃO IMIGRANTE</option>
                                        <option value="O">OUTRO/NÃO SEI</option>
                                    </select>
                                </div>
                                <button
                                    style={{ color: " red", backgroundColor: '#ffffff00', marginBottom: "20px", padding: "5px", border: "solid 1px  red", borderRadius: "20px" }}
                                    type="button" onClick={() => removeEntry('parentesImediatos', index)}>- Remover</button>
                            </div>
                        ))}
                        {formData.parentesImediatos.length < 10 && (
                            <button type="button" onClick={() => addEntry('parentesImediatos')}>+ Adicionar Contato</button>
                        )}
                    </div>
                )}
            </div>














        </div>
    );
}